'use strict';
var isInitialPageLoad = true;
var isCalcFirstLoad = true;
var thisModel;
var thisResult;
var thisvin;
var thisDealer;
var thisFinanceOffers = [];
var thisMonthly;
var thisDownpayment;
var thisMSRP;
var thisDefaultAPR;
var HasBuyOnline = 'false';
var BuyOnlineURL = '';
var isLocal = false;
var dataURL = 'https://acuracertifieddev.rpa-dev.com';
var vpdSlider, overlySlider, sliderThumb;
var vdpWrapper = $('#vehicle-details-wrapper');

var setDataPath = function() {
    var usedev = getParameterByName('usedev');
    switch (usedev) {
        case '1': 
            dataURL = 'https://acuracertifieddev.rpa-dev.com';
            break;
        case '2':
            dataURL = 'https://acuracertifieddev2.rpa-dev.com';
            break;
        default:
            dataURL = '';
    }
}

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)','i'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

var thisModelData = {
    DSRP: '',
    Features_PackageName: '',
    Features: '',
    CPOTier: '',
    VehicleType: '',
    ModelYear: '',
    ModelGroupName: '',
    Mileage: '',
    MilesAway: '',
    DealerID: '',
    DealerName: '',
    DealerAddress: '',
    DealerCity: '',
    DealerZip: '',
    DealerState: '',
    DealerURL: '',
    ModelMarketingName: '',
    PhotoLink: '',
    Photos: [],
    Photos_Count: 0,
    VehicleImage: '',
    PhotosNoImage: '',
    ModelTrim: '',
    ModelId: '',
    modelYearStart: '0',
    modelYearEnd: '0',
    ModelExteriorColorCD: '',
    ModelInteriorColorCD: '',
    modelPriceLimit: '0',
    ModelTransmission: '',
    ModelTransmissionMarketingName: '',
    VIN: '',
    HasBuyOnline: 'false',
    BuyOnlineURL: '',
    StockNo: '',
    VHRUrl: '',
    ICEUrl: '',
    DealerPhoneNumber: '',
    DealerHours: '',
    SingleOwner: '',
    Specials: '',
    SampleAPR: '',
    SampleTerm: '',
    hasOffer: '0',
    hasOfferTitle: '',
    isOfferApplied: '',
    offerApr: '',
    offerTerm: '',
    offerAprVdp: '',
    offerTermVdp: '',
    maxTerm: '',
    offerDisclaimer: '',
    offerDescription: '',
    engineText: '',
    cityText: '',
    highwayText: '',
    comboText: '',
    driveTrain: '',
    transmissionType: ''
    }


var setFeature = function(result) {
    if (thisModel.ModelGroupName.toLowerCase() != 'nsx') {
        thisModelData.Features_PackageName = result.PackageName;
        thisModelData.Features = result; 
        $('#keyFeatures').show();
        //key feature
        if (thisModelData.Features.KeyFeatures.length > 0 ) {
            $('#keyFeatures #keyFeature').show();
            for (var k=0;k<thisModelData.Features.KeyFeatures.length;k++) {
                $('#keyFeatures #keyFeature .items').append('<li class="cp-3">'+ thisModelData.Features.KeyFeatures[k] +'</li>');
            }
        } else {
            $('#keyFeatures #keyFeature').hide();
        }
        //package feature
        if (thisModel.ModelMarketingName != null) {
            if (thisModel.ModelMarketingName.trim().length > 0 && thisModelData.Features.PackageFeatures.length > 0) {
                $('#keyFeatures #PackageFeature').show();
                $('#keyFeatures #PackageFeature .title').html(thisModel.ModelMarketingName);
                for (var p=0;p<thisModelData.Features.PackageFeatures.length;p++) {
                    $('#keyFeatures #PackageFeature .items').append('<li class="cp-3">'+ thisModelData.Features.PackageFeatures[p] +'</li>');
                }
            } else {
                $('#keyFeatures #PackageFeature').hide();
            }
        } else {
            $('#keyFeatures #PackageFeature').hide();
        }


        if (thisvin.DealerDescription != null) {
            if (thisvin.DealerDescription.trim().length > 0) {
                $('#keyFeatures #featureDealerDesc').show();
                $('#keyFeatures #featureDealerDesc .copy').html(thisModel.DealerDescription);
            } else {
                $('#keyFeatures #featureDealerDesc').hide();
            }            
        }

    } else {
        $('#keyFeatures').hide();
    }
}

var setVehicleDetail = function (result) {

    thisResult = result.Output.Results;
    thisModel = result.Output.Results.Models.Model[0];

    thisvin = thisModel.ModelVINsOnSite.VIN[0];
    thisDealer = thisResult.Dealers.Dealer[0];

    if (thisResult.Specials) {
        const index = thisResult.Specials.Special.map((special) => special["SalesProgramTypeCD"]).indexOf('R');
        if (index !== -1) {
            thisFinanceOffers = thisResult.Specials.Special[index].PaymentTerms.FinanceTerms.FinanceTerm;  
        }        
    }
    

    var ModelId = (thisModel['@ModelId'] != '') ? thisModel['@ModelId'] : '';
    thisModelData.ModelId = ModelId;

    getFeature();
    var ModelYear = thisModel.ModelYear;
    document.getElementById('epa-disclaimer').dataset.disclaimersContent = window.acpv.epaDisclaimers[ModelYear];
    thisModelData.ModelYear = ModelYear;
    var ModelGroupName = thisModel.ModelGroupName;
    thisModelData.ModelGroupName = ModelGroupName;
    var ModelTrim = thisModel.ModelTrim;
    thisModelData.ModelTrim = ModelTrim;
    var ModelMarketingName = thisModel.ModelMarketingName;
    thisModelData.ModelMarketingName = ModelMarketingName;
    var ModelTransmission = (thisModel.ModelTransmission != 'null') ? thisModel.ModelTransmission : '';
    thisModelData.ModelTransmission = ModelTransmission;
    var ModelTransmissionMarketingName = thisModel.ModelTransmissionMarketingName;
    thisModelData.ModelTransmissionMarketingName = ModelTransmissionMarketingName;
    var VIN = thisvin.VIN;
    thisModelData.VIN = VIN;
    var VehicleType = thisvin.VehicleType;
    var CPOTier = thisvin.CPOTier;
    thisModelData.CPOTier = CPOTier;
    thisModelData.VehicleType = VehicleType;
    var Mileage =  thisvin.Mileage;
    thisModelData.Mileage = Mileage;
    var DSRP = thisvin.DSRP;
    thisModelData.DSRP = DSRP;

    if(thisFinanceOffers.length && (CPOTier !== 'BT' && VehicleType !== 'U')) {
        $('.vdp-offers').removeClass('hidden');
    }

    var buyOnlineData = (thisvin.BuyOnline == null || thisvin.BuyOnline == 'undefined') ? null : thisvin.BuyOnline;
        if (buyOnlineData != null) { 
            HasBuyOnline = thisvin.BuyOnline['@OnlineRetailingPreferredVIN'];
            BuyOnlineURL = thisvin.BuyOnline['@VehicleDetailPageURL'];
        }
    thisModelData.HasBuyOnline = HasBuyOnline;
    thisModelData.BuyOnlineURL = BuyOnlineURL;

    var StockNo = thisvin.StockNo;
    thisModelData.StockNo = StockNo;
    var SingleOwner = (thisvin.SingleOwner == null) ? "false" : thisvin.SingleOwner;
    thisModelData.SingleOwner = SingleOwner;
    var CourtesyVehicle = thisvin.CourtesyVehicle;
    thisModelData.CourtesyVehicle = CourtesyVehicle;

    var specialCountsEmpty = thisResult.Specials ? thisResult.Specials.Special.map(special => special['SalesProgramTypeCD']).indexOf('R') !== -1 : false;
    var SampleAPR = '';
    var SampleTerm = '';
    var specials = '';

    if (specialCountsEmpty) { 
        SampleAPR = thisResult.Specials.Special[0].PaymentTerms.FinanceTerms.SampleFinancePayment.SampleAPR;
        SampleTerm = thisResult.Specials.Special[0].PaymentTerms.FinanceTerms.SampleFinancePayment.SampleTerm;
        specials =  thisResult.Specials.Special[0];
        thisModelData.SampleAPR = SampleAPR;
        thisModelData.SampleTerm = SampleTerm;
        thisModelData.Specials = specials;
    }
  


    var VHRUrl = '';
    var VHRType = ''
    if (
        (thisvin.VHRUrl["@Source"].toLowerCase() == "carfax") ||
        (thisvin.VHRUrl["@Source"].toLowerCase() == "autocheck")
       )
    {
        VHRUrl = (thisvin.VHRUrl["#text"] == null) ? '' : thisvin.VHRUrl["#text"];
        VHRType = (thisvin.VHRUrl["@Source"] != null) ? thisvin.VHRUrl["@Source"].toLowerCase() : '';
    }
    //console.log('fdsa', thisvin)
    var ICEUrl = (thisvin.ICEUrl != null) ? thisvin.ICEUrl: '';
    thisModelData.VHRUrl = VHRUrl;
    thisModelData.VHRType = VHRType;
    thisModelData.ICEUrl = ICEUrl;

    var ModelExteriorColorName = thisvin.ModelExteriorColorName;
    var ModelExteriorColorCD = thisvin.ModelExteriorColorName;
    var ModelBaseColor = thisvin.ModelBaseColor;
    var ModelInteriorColorName = thisvin.ModelInteriorColorName;
    var ModelInteriorColorCD = thisvin.ModelInteriorColorName;
    thisModelData.ModelExteriorColorCD = ModelExteriorColorName;
    thisModelData.ModelInteriorColorCD = ModelInteriorColorName;
    
    

    var dnotes = thisvin.DealerDescription;
    var DealerDescription = dnotes;
    if (DealerDescription != null) {
       if (dnotes.indexOf("<h2") > 0 || dnotes.indexOf("<div") > 0 || dnotes.indexOf("<p") > 0 || dnotes.indexOf("<br") > 0)  //if there's an html code in dealernotes, handle 
        {
            DealerDescription = '';
        }
    } else {
        DealerDescription = '';
    }


    var ModelAttributes = [];  //VIN no photos:

    for (var i = 0; i < thisModel.ModelAttributes.ModelAttribute.length; i++)
    { 
        for (var j = 0; j < thisResult.ModelAttributes.ModelAttribute.length; j++)
        { 
            if (thisModel.ModelAttributes.ModelAttribute[i] == thisResult.ModelAttributes.ModelAttribute[j]["@id"])
            {
               // ModelAttributes.Add(new KeyValuePair<string, string>(results["ModelAttributes"]["ModelAttribute"][j]["@Name"].ToString(), results["ModelAttributes"]["ModelAttribute"][j]["@Value"].ToString()));
               ModelAttributes.push({
                key:   thisResult.ModelAttributes.ModelAttribute[j]["@Name"],
                value:  thisResult.ModelAttributes.ModelAttribute[j]["@Value"]
                });
            }
        } 
    }     

    var photos = '';
    if ( thisModel.ModelVINsOnSite.VIN[0].Photos != null) {
        photos = thisModel.ModelVINsOnSite.VIN[0].Photos.Photos.Photo;
    }
 
    var ModelStockPhotos = [];
    var thisModelPhotos = [];
    var thisModelStockPhotos = [];
    try
    { 
        for (var i=0; i<photos.length; i++)
        {
            //check image dimension before adding to collection
            //if (validPhotoVehicle(photos[i]["#text"]))
            //{
                thisModelPhotos.push(photos[i]["#text"]);

            //} 
        } 
    }
    catch (ex)
    {
        console.log(ex)
    }

    try
    { 
        if (thisvin.ModelStockPhotos != null) {
            ModelStockPhotos = thisvin.ModelStockPhotos.Photos;
            for (var i=0; i<ModelStockPhotos.length; i++)
            {
                //check image dimension before adding to collection
                //if (validPhotoVehicle(photos[i]["#text"]))
                //{
                    thisModelStockPhotos.push(ModelStockPhotos[i].Photos.Photo);
                //} 
            } 
        }
    }
    catch (ex)
    {
        console.log(ex)
    }

    var videos = [];
    if (thisModel.ModelVINsOnSite.VIN[0].Videos != null) {
        videos = thisModel.ModelVINsOnSite.VIN[0].Videos;
    } else {
        
    }

    thisModelData.Photos = photos;

    //set video
    var videoPhotoStr = '';
    var videoStr = '';
    var photoStr = '';

    var thumbphotovideoStr = '';
    var videothumb = '';
    var photothumb = '';

    if (videos.length > 0) {
        for (var j = 0; j < videos.Video.length; j++)
        {
            if (videos.Video[j]["@Type"] == "E")
            {
                videoStr = videos.Video[j]["#text"];
            }
        }        
        videoPhotoStr += '<div class="video-player">';
        videoPhotoStr += '  <iframe frameborder="0" id="main-iframe-video" src="'+ videoStr +'&auto_resize=1" scrolling="no" allowfullscreen=""></iframe>';
        videoPhotoStr += '</div>';

        videothumb += '<div class="item">';
        videothumb += '    <div class="content">';
        videothumb += '        <img src="/public/images/vehicle-details/video-thumbnail.png" border="0" alt="">';
        videothumb += '    </div>';
        videothumb += '</div>';
    } else {
        
    }
  
    if (photos.length > 0) {
        for (var p=0;p<photos.length;p++) {
            photoStr += '<div class="item">';
            photoStr += '    <div class="content">';
            photoStr += '        <img src="'+ photos[p]['#text']  +'" border="0" alt="">';
            photoStr += '    </div>';
            photoStr += '</div>';

            photothumb += '<div class="item" data-tap-element-id="vpd_gallery_thumb">';
            photothumb += '    <div class="content">';
            photothumb += '        <img src="'+ photos[p]['#text']  +'" border="0" alt="">';
            photothumb += '    </div>';
            photothumb += '</div>';

            $('.thumbnail-slider-container').show();
        }
        thisModelData.Photos_Count = photos.length;
        thisModelData.PhotoLink = photos[0]['#text'];
        thisModelData.VehicleImage = photos[0]['#text'];
        videoPhotoStr += photoStr;
        thumbphotovideoStr = videothumb + photothumb

        //hide gallery before it loads
        $('#vehicle-details-wrapper .gallerySlide').css('visibility', 'hidden');

        //insert content to gallery and thumbnails
        $('#vehicle-details-wrapper #slider').html(videoPhotoStr)
        $('#vehicle-details-wrapper .photo-slider-container .total-count').html(photos.length)
        $('.thumbnail-slider-container #thumbnailSlider').html(thumbphotovideoStr)
        //inset content for overlay
        $('#inventory-details-fullpreview #slider-overlay').html(photoStr);
        
        //insert image to contact dealer modal
        $('.vehicle-img-wrapper img').attr('src',thisModelData.VehicleImage);

        var slider = $('#slider');
        var thumbnailSlider = $('#thumbnailSlider');
        var sliderOverlay = $('#slider-overlay');
        var duration = 250;
        //add count again
        $('.total-count').html(photos.length);
        // Hide navigation buttons if only 1 image
        if (photos.length == 1) {
            $('.slider-previous-btn, .slider-next-btn').css({'cssText': 'display: none !important'});;
        }

        //load Carousel in a delay to prevent flicker
        setTimeout(function () {
            // Make first thumbnail active
            $("#thumbnailSlider .item:eq(0) img").css("border-bottom", "2px solid red");
            // carousel function for photo gallery
            vpdSlider = slider.owlCarousel({
                loop: false, //rpaik
                nav: false,
                items: 1
            }).on('changed.owl.carousel', function(e) {
                // On change of main item to trigger thumbnail item
                thumbnailSlider.trigger('to.owl.carousel', [e.item.index, duration, true]);
                // Remove active state from all thumbnail and add it to selected item
                var thumbIndex = e.item.index;
                //console.log("Line 113: thumbIndex: " + thumbIndex)
                        
                $("#thumbnailSlider").find("*").css("border", "0");
                //sets border on staged item
                $("#thumbnailSlider .item:eq(" + thumbIndex + ") img").css("border-bottom", "2px solid red");
                // Change counter on mobile
                $('.current-position').html(thumbIndex+1);
            }).on('click', '.owl-item', function() {
                // On click of image to trigger overlay same photo item
                sliderOverlay.trigger('to.owl.carousel', [$(this).index(), duration, true]);
                //console.log("owl item this.index: " + $(this).index())
            }); 


            // carousel function for thumbnail gallery
            sliderThumb = thumbnailSlider.owlCarousel({
                loop: false, //rpaik
                nav: false,
                center: false,
                responsive: {
                    0: {
                        items: 0
                    },
                    600: {
                        items: 6,
                        slideBy: 6
                    },
                    1000: {
                        items: 6,
                        slideBy: 6
                    }
                }
            }).on('click', '.owl-item', function() {
                // On click of thumbnail items to trigger same photo item
                slider.trigger('to.owl.carousel', [$(this).index(), duration, true]);
                // On click of image to trigger overlay same photo item
                sliderOverlay.trigger('to.owl.carousel', [$(this).index(), duration, true]);
                // Remove active state from all thumbnail and just add it to clicked item
                var thumbIndex = $(this).index();
                $("#thumbnailSlider").find("*").css("border", "0");
                $("#thumbnailSlider .item:eq(" + thumbIndex + ") img").css("border-bottom", "2px solid red");
            });                

            $('#vehicle-details-wrapper .gallerySlide').css('visibility', 'visible');
        }, 1500);
        


            //slider-overlay-container slider-overlay
            overlySlider = sliderOverlay.owlCarousel({
                loop: false,
                nav: false,
                items: 1
            });

        
        



    } else {
        getAltPhoto();
        $('#vehicle-details-wrapper .photo-counter').css({'cssText': 'display: none !important'});
        $('#vehicle-details-wrapper .slider-previous-btn').css({'cssText': 'display: none !important'});
        $('#vehicle-details-wrapper .slider-next-btn').css({'cssText': 'display: none !important'});
    }
    


    var FeaturesPackageName = '';
    //if (Features.PackageName == null)
    //{
    //    Features.PackageName = '';
    //}

    //stock and vin
    var thisStock = thisvin.StockNo;

    $('.vin-stock .vinNumber').html(VIN);
    $('.vin-stock span.cp-12').html(thisStock);
    $('.vin span.cp-12').html(VIN);
    $('.dealer-stock span.cp-12').html(thisStock);

    //buy online data
    if (HasBuyOnline != 'false') {
        $('.vehicle-info #buyOnline').removeClass('hidden');
    }else {
        $('.vehicle-info .contact-dealer-btn').addClass('col-md-12');
    }

    //offer
    if (VehicleType != 'U') {
        $('.vehicle-info #offerSection').removeClass('hidden');
        $('#mobileOffers').removeClass('hidden');
    }

    //ice
    if(CPOTier === 'BT') {
        $('.ICE-container span').addClass('point-112');
    }else {
        $('.ICE-container span').addClass('point-182');
    }

    //v type
    if (VehicleType != "U") {
        if(CPOTier === 'BT') {
            $('.benefit-112').removeClass('hidden');
            $('.vehicle-info .vehicle-type-precision-used').show();
        }else {
            $('.benefit-182').removeClass('hidden');
            $('.vehicle-info .vehicle-type-precision').show();
        }
    } else {
        $('.vehicle-info .vehicle-type-used').show();
        $('.ICE-container span').addClass('hidden');
    }

    //set model year
    $('.vehicle-info .year-model h1').html(ModelYear + ' ' + ModelGroupName);
    $('.modelGroupName').html(ModelGroupName)
    $('.vehicle-info-wrapper .year-model h2').html(ModelYear + ' ' + ModelGroupName);
    $('.calculate-inventory-details-wrapper .year-model h2.hidden-xs').html(ModelYear + ' ' + ModelGroupName);
    $('.calculate-inventory-details-wrapper .year-model h2.visible-xs').html(ModelYear + ' ' + ModelGroupName);

    //set vin
    $('.vehicle-info-wrapper .vin span.cp-12').html(VIN);
    $('.calculate-inventory-details-wrapper .vin span.cp-12').html(VIN);

    //set marketing name
    if (ModelMarketingName != '') {
        $('.vehicle-info .package span').html(ModelMarketingName);
        $('.vehicle-info-wrapper .package span').html(ModelMarketingName);
        $('.calculate-inventory-details-wrapper .package span').html(ModelMarketingName);
    } else {
       $('.vehicle-info .package span').html(PACKAGE);
       $('.vehicle-info .package').css('visibility','hidden');
    }

    //set miles
    $('.vehicle-info .miles span.mileage').html(Number(Mileage).toLocaleString('en-US') + ' miles');
    $('.contact-dealer-wrapper .vehicle-info-wrapper .miles span.cp-10').html(Number(Mileage).toLocaleString('en-US') + ' miles');
    $('#calculate-inventory-details-wrapper .vehicle-info-wrapper .miles span').html(Number(Mileage).toLocaleString('en-US') + ' miles');

    //set price (DSRP)
    $('.vehicle-info .price span').html('$' + Number(DSRP).toLocaleString('en-US'));
    $('#inventory-details-contact .vehicle-info-wrapper .price span.hl-6a').html('$' + Number(DSRP).toLocaleString('en-US'));
    $('#calculate-inventory-details-wrapper .vehicle-info-wrapper .price span').html('$' + Number(DSRP).toLocaleString('en-US'));

    $('.calculate-inventory-details-wrapper .details-info-right .errMessage span').html('Downpayment and trade-in value combined must not exceed $'+ (Number(DSRP) - 5000).toLocaleString('en-US')  +'.')

    //offers
    thisFinanceOffers.sort((a,b) => parseFloat(b.APR) - parseFloat(a.APR));
    const disc = window.acpv.currentOffer;
    if(CPOTier !== 'BT' && VehicleType !== 'U') {
        for(let i=0; i< thisFinanceOffers.length; i++) {
            let offer = thisFinanceOffers[i];
            let offerValue = JSON.stringify(offer);
            const idElement = `${offer.APR}_radio`;
            $('.vdp-offers .form-group').prepend(`<div>
                <radio><input class="radio-offer" type="radio" id="${idElement}" name="radio-offers-group" value='${offerValue}'></radio>
                <label for="${idElement}">${offer.APR}% APR up to ${offer.TermMax} months <sup><a style="font-size: 20px;" class="disclaimer-callout" data-disclaimers-content="${disc}">*</a></sup></label>
                </div>`);
        }
    }


    $(document).on('change', '.vdp-offers .radio-offer', function(e) {
        const value = e.target.value;
        const offerSelected = JSON.parse(value);
        const {APR, TermMax} = offerSelected;
        $('.vdp-offers radio').removeClass('checked');
        if(e.target.checked) {
            this.parentElement.classList.add('checked');
            vdpWrapper.attr('data-tap-offer-term', `${APR}% APR up to ${TermMax} months`);

            if(e.target.id === 'no_offer') {
                calculateMonthly(null);
                return;
            }      
            
            calculateMonthly({apr: APR, term: TermMax});
        }
    });

    if (ModelGroupName.toLowerCase() != "nsx")
    {
        $('#cmp').append('<div class="calculate-monthly hidden"><a href="#" id="calculate-monthly-link" data-tap-element-id="vpd_calculate" onclick="calcOpen()"><span class="cp-13">Payment Calculator</span></a></div>');
        
    }



    var DealerID = thisModel["@DealerId"];
    thisModelData.DealerID = DealerID;
    var DealerName = thisDealer.DealerName;
    thisModelData.DealerName = DealerName;
    var DealerURL = thisDealer.DealerURL;
    thisModelData.DealerURL = thisDealer.DealerURL;
    var DealerAddress = thisDealer.DealerAddress;
    thisModelData.DealerAddress = DealerAddress;
    var DealerCity = thisDealer.DealerCity;
    thisModelData.DealerCity = DealerCity;
    var DealerState = (thisDealer.DealerState == null) ? '' : thisDealer.DealerState;
    thisModelData.DealerState = DealerState;
    var DealerZip = (thisDealer.DealerZip == null) ? '' : thisDealer.DealerZip.slice(0,5) + '-' + thisDealer.DealerZip.slice(5, thisDealer.DealerZip.length);
    thisModelData.DealerZip = DealerZip;
    var DealerPhoneNumber = thisDealer.DealerPhoneNo.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    thisModelData.DealerPhoneNumber = DealerPhoneNumber;
    var dealerHours = (thisDealer.DealerHours == null) ? '' : formatDealerhours(thisDealer.DealerHours);
    thisModelData.DealerHours = dealerHours;

    //contact confirmation dealer name
    $('#thankyou span.confirmationdealername').html(DealerName);

    //insert Dealer name and distance
    $('.vehicle-info .dealerName').html(DealerName);
    $('.vehicle-info .miles .dealer-website').text(DealerName);
    $('.vehicle-info .miles .dealer-website').attr('href', DealerURL);
    //$('.dealer-info-wrapper .miles-away .dealer-website').attr('href',DealerURL);

    $('.calculate-inventory-details-wrapper .miles-away').text(DealerName);
    $('.calculate-inventory-details-wrapper .miles-away').attr('href',DealerURL);

    $('.calculate-inventory-details-wrapper .dealer p span a').text(DealerName);
    $('.calculate-inventory-details-wrapper .dealer p span a').attr('href',DealerURL);

    //insert all dealer zip
    var _address = DealerAddress.trim() + "," + DealerCity.trim() + " " + DealerState.trim() + " " + DealerZip;
    var binglink = "https://www.bing.com/maps?rtp=~adr." + _address;
    $('.dealer-address-wrapper .dealer-address-line1 a').attr('href',binglink);
    $('.dealer-address-wrapper .dealer-address-line1 a').text(DealerAddress);

    $('.dealer-address-wrapper .city a').attr('href',binglink);
    $('.dealer-address-wrapper .city a').text(DealerCity+ ', '+ DealerState + ', '+ DealerZip);

    $('.dealer-info-wrapper .dealer-info .dealer-address-wrapper a').attr('href',binglink);



    //insert all dealer phone number
    $('.dealer-info-row .dealer-phone').html(DealerPhoneNumber);
    $('._dealerPhoneFormatted').val(DealerPhoneNumber);
    $('.dealer-phone-wrapper .phone-red a').attr("href", "tel:"+DealerPhoneNumber);
    $('.dealer-phone-wrapper .dealer-phone a').attr("href", "tel:"+DealerPhoneNumber);
    $('.dealer-phone-wrapper .dealer-phone a').text(DealerPhoneNumber);

    //insert dealer hours
    if (dealerHours.length > 0) {
        for (var i=0;i<dealerHours.length;i++) {
            $('.hours .copy-left').append('<p class="cp-9">'+ dealerHours[i].day+'</p>')
            $('.hours .copy-right').append('<p class="cp-9">'+ dealerHours[i].time+'</p>')
        }
    } else {
        $('.hours').hide();
    }

    var no_photo_image = window.location.hostname + "/-/media/F66501FA28274458B47D88D252E2A600.ashx";
    //handle of photos count = 0
    if (thisModelPhotos.length == 0)
    {
        //var got_photo = getAlternateVehiclePhoto(vin, inventoryModel.DealerZip);
        var got_photo = 'null';
        //if no deaaler photos and stock photos, default to no image available
        if (got_photo != 'null')
        {
            thisModelPhotos.push(got_photo);
        } else
        {
            thisModelPhotos.push(no_photo_image);
        }
         
    }

    //save no image photo for similar vehicles without images
    var PhotosNoImage = no_photo_image;
    thisModelData.PhotosNoImage = PhotosNoImage;

    //overview section
    if (ModelGroupName.toLowerCase() != 'nsx') {

        //show notnsx section
        $('#overview-section #notnsx').removeClass('hidden');
        $('#overview-section #notnsx').addClass('visible-xs');

        if ($('#header-gallery #notnsx-header').length > 0) {
            $('#header-gallery #notnsx-header').removeClass('hidden');
            $('#header-gallery #notnsx-header').addClass('visible-lg');
        } else {
            $('#overview-section #notnsx').addClass('visible-lg');
        }

        

        var eng = ModelAttributes.find(x => x.key === 'Engine Name').value;
        var drive = ModelAttributes.find(x => x.key === 'DRIVE').value;
        var epaText = ModelAttributes.find(x => x.key === 'City Fuel Efficiency').value + ' city / ' + ModelAttributes.find(x => x.key === 'Highway Fuel Efficiency').value+ ' hwy / ' + ModelAttributes.find(x => x.key === 'COMB_MPG').value + ' combined';
        thisModelData.engineText = eng;
        thisModelData.driveTrain = drive;
        thisModelData.cityText = ModelAttributes.find(x => x.key === 'City Fuel Efficiency').value;
        thisModelData.highwayText = ModelAttributes.find(x => x.key === 'Highway Fuel Efficiency').value;
        thisModelData.comboText = ModelAttributes.find(x => x.key === 'COMB_MPG').value;
        thisModelData.transmissionType = drive;

        $('#overview-section .engineText').html(eng)
        $('#header-gallery .engineText').html(eng);

        $('#overview-section .transmission').html(ModelTransmissionMarketingName)
        $('#header-gallery .transmission').html(ModelTransmissionMarketingName);

        $('#overview-section .driveTrain').html(drive);
        $('#header-gallery .driveTrain').html(drive);

        $('#overview-section .epaText').html(epaText);
        $('#header-gallery .epaText').html(epaText);

        $('#overview-section .exteriorColor').html(ModelExteriorColorName);
        $('#header-gallery .exteriorColor').html(ModelExteriorColorName);

        $('#overview-section .interiorColor').html(ModelInteriorColorName);
        $('#header-gallery .interiorColor').html(ModelInteriorColorName);
    
        if (VHRUrl != '') {
            $('#overview-section #overview_carfax').removeClass('hidden');
            $('#overview-section #overview_carfax .carfax-container a').attr('href',VHRUrl);
            
            $('#header-overview-section #overview_carfax').removeClass('hidden');
            $('#header-overview-section #overview_carfax').removeClass('hidden');
        } else {
            $('#overview-section #no_overview_carfax').removeClass('hidden');

            $('#header-overview-section #no_overview_carfax').removeClass('hidden');
        }
    
        if (VHRUrl != '' && VHRType == 'autocheck' && VehicleType != 'U')
        {
            $('#overview-section #overview_autocheck .autocheck-container a').attr('href',VHRUrl);
            $('#overview-section #overview_autocheck').removeClass('hidden');

            $('#header-overview-section #overview_carfax .autocheck-container a').attr('href',VHRUrl);
            $('#header-overview-section #overview_carfax').removeClass('hidden');
        }
    
        if (ICEUrl != '' && VHRType == 'carfax')
        {
            $('#overview-section #overview_ICE .ICE-container a').attr('href',ICEUrl);
            $('#overview-section #overview_ICE').removeClass('hidden');

            $('#header-overview-section #overview_ICE .ICE-container a').attr('href',ICEUrl);
            $('#header-overview-section  #overview_ICE').removeClass('hidden');
        }
    

    } else {
        $('#overview-section #isnsx').removeClass('hidden');
        if ((DealerDescription.toLowerCase() != '' && (VHRUrl == '') && ICEUrl == '')) {
            //show nsx dealer notes
            //currently we are hiding notes
            //$('#isnsx #nocarfax').removeClass('hidden');
            $('#isnsx #nocarfax .features p.copy-nsx').html(DealerDescription);

        } else {
            $('#hascarfax').removeClass('hidden');

            if (DealerDescription != '') {
                //currently we are hiding the notes
                //$('#isnsx #hascarfax #dealerNotes-carfax').removeClass('hidden');
                $('#isnsx #hascarfax #dealerNotes-carfax p.copy').html(DealerDescription);
            }

            if (VHRType == 'carfax' && VHRUrl != '') {
                $('#isnsx #hascarfax #overview-section #overview_carfax_nsx').removeClass('hidden');
                $('#isnsx #hascarfax #overview-section .carfax-container a').attr('href',VHRUrl);
            }

            if (VHRUrl != '' && VHRType == 'autocheck') {
                $('#isnsx #hascarfax #overview-section #overview_autocheck_nsx').removeClass('hidden');
                $('#isnsx #hascarfax #overview-section .autocheck-container a').attr('href',VHRUrl);
            }
            if (ICEUrl != '') {
                $('#isnsx #hascarfax #overview-section #overview_ICE_nsx').removeClass('hidden');
                $('#overview_ICE').removeClass('hidden');
                $('#isnsx #hascarfax #overview-section .ICE-container a').attr('href',ICEUrl);
            }else {
                console.log('jasdlfkjsa')
                $('#overview-section #no_overview_carfax').removeClass('hidden');
            }
        }
    }


    //benefit module
    if (VehicleType != 'U') {
        $('.benefit-module .benefit-cert').removeClass('hidden');
    } else {
        $('.benefit-module .benefit-used').removeClass('hidden');
    }

    //console.log(thisModelData)
    $('.vdploader .spinner').hide();
    if (thisModelData.VIN != '') {
        $('.vdploader .spinner').css('top','50%');
        $('.spinner').show();
        //set distance from dealer fields
        getDistanceFromDealer();
        //start calculate on initial load of calc overlay
        setTimeout(function() {
            //set lower or default apr.
            if(CPOTier !== 'BT' && VehicleType !== 'U' && thisFinanceOffers.length) {
                $('.vdp-offers .form-group div:first-child').find('input').trigger('click')
            }else {
                calculateMonthly(null);
            }
        }, 500);
        //check chat and text status
        // getContactOnceStatus();
        //load related vehicles and dealers info section 
        getVehicleDealerObject();
    }

    //set vdp wrapper tap data
    vdpWrapper.attr('data-tap-element-id','vdp-details');
    vdpWrapper.attr('data-tap-dealer-name',thisModelData.DealerName);
    vdpWrapper.attr('data-tap-dealer-id',thisModelData.DealerID);
    //vdpWrapper.attr('data-tap-dealer-distance','');
    //distance is set in the dealer distance ajax call around line 2187
    if (thisModelData.HasBuyOnline == 'true') {
        vdpWrapper.attr('data-tap-dealer-options','buyonline');
    } else {
        vdpWrapper.attr('data-tap-dealer-options','default');
    }

    vdpWrapper.attr('data-tap-model-name',thisModelData.ModelGroupName);
    vdpWrapper.attr('data-tap-model-year',thisModelData.ModelYear);
    vdpWrapper.attr('data-tap-model-trim',thisModelData.ModelTrim);
    vdpWrapper.attr('data-tap-model-mspr',thisModelData.DSRP);
    vdpWrapper.attr('data-tap-model-exterior-color',thisModelData.ModelExteriorColorCD);
    vdpWrapper.attr('data-tap-model-interior-color',thisModelData.ModelInteriorColorCD);
    let ProgramID = (VehicleType != 'U') ? CPOTier === 'BT' ? 'precision_used' : 'precision_certified':'used';
    vdpWrapper.attr('data-tap-model-program-id',ProgramID);
    vdpWrapper.attr('data-tap-offer-type','finance');
    vdpWrapper.attr('data-tap-offer-term',thisModelData.SampleTerm);
    //offer description is set in offer function => showOffersVDP
    //vdpWrapper.attr('data-tap-offer-monthly','');
    //vdpWrapper.attr('data-tap-offer-description',thisModelData.Specials.SpecialDescription);
    vdpWrapper.attr('data-tap-offer-code',thisModelData.Specials.SalesProgramCode)
    vdpWrapper.attr('data-tap-offer-availability',thisModelData.Specials.EndDate);
    vdpWrapper.attr('data-tap-offer-id',thisModelData.Specials.SpecialID);
    //end of vdp wrapper tap

}

$(document).ready(function() {
    $('.vdploader .spinner').css('top','200px');
    $('.vdploader .spinner').show();
    setDataPath();
    getVehicleDetails();
    //console.log(thisModel);
    //Adding cta buy online
    $('#continue-cta-buy-online').on('click' , function(){
        window.open(BuyOnlineURL, "_blank");

        $("#buyOnlineModal").modal('hide');
    });

    //for buyline tap
    $('#buyOnlineModal').on('show.bs.modal', function () {
        setTimeout(() => {
            if(typeof window.TapCallback === "function") {
                window.TapCallback({
                   "context": "inventory-buyonline-modal"
                });
             }
        }, 500);
    });
    $('#tooltip-info-certified-used').tooltip({trigger: 'click'});
    $('#tooltip-info-certified').tooltip({trigger: 'click'});
    //Start contact dealer form code
    //initialize the dropbox
    //coptbox();
    //on click, open and close the dropdown

    //adding monthly payment pre-calculation with 10% down
    var currentMSRP = Number(thisModelData.DSRP);
    var dp = Math.round(currentMSRP / 10);
    var previousAPR;
    
    // console.log("price :" + currentMSRP);
    // console.log("10% :" + dp);
    $('#txt-downpayment').val(dp);
    $('.calculate-monthly #calculate-monthly-link').click();

    // $('.mpestIcon, .fair-info-i').tooltip({
    $('.mpestIcon').tooltip({
        animated: 'fade',
        placement: 'bottom',
        trigger: 'click'
    });

    $(".contact-option-box").click(function() {
        $(".chevron-down-red").toggleClass("open");
        $("ul li.contact-opt:nth-child(n+2)").toggle();
    });
    //
    $("ul li.contact-opt:nth-child(n+2)").click(function() {
        hideDivError("#errpreferred");
        //console.log("option text: " + $(this).text())
        $("ul li.contact-opt").each(function() {
            //console.log("option text: " + $(this).text())
            $(this).removeClass("active");
        });
        $(this).addClass("active");
        coptbox();
        
    });

    $("#email, #phone, #text").blur(function(){
        hideDivError("#errpreferred");
    });

    let emailEntered = false;
    $("#contact-dealer-wrapper #email").one('keypress',function(){
        if(typeof window.TapCallback === "function") {
            window.TapCallback({
               "context": "inventory-contact-dealer-modal-start"
            });
         }
    });

    //initialize

    //gets selected item and sets the value in the display of the dropdown. 
    //Default is the first item
    function coptbox() {
        $("ul li.contact-opt").each(function() {
            console.log("option text: " + $(this).text())
            if ($(this).hasClass("active")) {
                $("#display").children("p").text($(this).text());
                setCoptTextBox($(this).text());
            }
        });
    }
    //changes all the attributes of the associated textbox selected in the dropdown
    function setCoptTextBox(opttype) {
        $(".opttxtbox").css("display", "none");
        $('[name='+ opttype.toLowerCase() + ']').toggle();
        // $(".opttxtbox").attr("name", opttype.toLowerCase());
        // $(".opttxtbox").attr("id", opttype.toLowerCase());
        // $(".opttxtbox").attr("placeholder", opttype.toLowerCase());
        // if($(".opttxtbox").attr("name") == "text" || $(".opttxtbox").attr("name") == "phone"){
        //     $(".opttxtbox").attr("placeholder", "phone #");
        //      $(".opttxtbox").attr("type", "tel");
        //      $(".opttxtbox").attr("maxlength", "10");
        // }else{
        //     $(".opttxtbox").attr("type", "text");
        //      $(".opttxtbox").removeAttr("maxlength");
        // }
        if (opttype.toLowerCase() == "text") {
            $(".data-rates span").css("display", "block");
        } else {
            $(".data-rates span").css("display", "none");
        }
    }
    //END Contact Dealer From Code

    // Input only accept numbers || 'e'
    $("#zip").keydown(function(e) {
        // Allow: backspace, delete, tab, escape, enter
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
            // Allow: Ctrl+A, Command+A
            (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: home, end, left, right, down, up
            (e.keyCode >= 35 && e.keyCode <= 40)) {
            // let it happen, don't do anything
            return;
        }
        //stop 'e'
        if (e.keyCode == 60) {
            e.preventDefault();
        }
        // Ensure that it is a number and stop the keypress
        if (((e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            $('#output').html(e.keyCode)
            e.preventDefault();
        }
    });
    new acpv.BottomBar();
    
    
    //rpaik
    function activeItemIndex(){
        var itemCount = 0;
        var activeIndex;
        $('#slider .owl-item').each(function(){ 
            if ($(this).hasClass("active")){
                activeIndex = itemCount;
            }else{
                itemCount++;
            }
        });
        return activeIndex;
    }
    

    // Previous and next navigation
    $('.slider-right').click(function() {
        //reload the iframe video
        reloadiFrame("main-iframe-video"); 
        
        //tracking
        _satellite.track("vehdetails_gallery_advanceright");
        
        vpdSlider.trigger('next.owl.carousel');
        overlySlider.trigger('next.owl.carousel');
        //rpaik
        if(activeItemIndex()+1 == thisModelData.Photos.length){
            var indexCount = 0;
            $("#thumbnailSlider .owl-item").each(function(index){
                if(index==0){
                       $(this).trigger("click");
                }
            });
        }
    });
    $('.slider-left').click(function() {
        //reload the iframe video
        reloadiFrame("main-iframe-video");

        //tracking
        _satellite.track("vehdetails_gallery_advanceleft");

        vpdSlider.trigger('prev.owl.carousel');
        overlySlider.trigger('prev.owl.carousel');
        //rpaik 
        if(activeItemIndex()==0){
            var indexCount = 0;
            $("#thumbnailSlider .owl-item").each(function(index){
                if(index==thisModelData.Photos.length-1){
                    $(this).trigger("click");
                }
            });
        }
    });
    // Thumbnail previous and next navigation
    $('.thumb-slider-right').click(function() {
        //tracking
        _satellite.track("vehdetails_gallery_advanceright");

        // sliderOverlay.trigger('next.owl.carousel');
        if(activeGroupIndexRight()){
            $("#thumbnailSlider .owl-item").each(function(index){
                if(index+1==thisModelData.Photos.length && $("#thumbnailSlider .owl-item").hasClass("active")){
                    
                    sliderThumb.trigger('prev.owl.carousel');
                    sliderThumb.trigger('prev.owl.carousel');
                    sliderThumb.trigger('prev.owl.carousel');
                    sliderThumb.trigger('prev.owl.carousel');
                }
            });
        }else{
            sliderThumb.trigger('next.owl.carousel');
        }
    });
    $('.thumb-slider-left').click(function() {
        
        //tracking
        _satellite.track("vehdetails_gallery_advanceleft");

        
        if(activeGroupIndexLeft()){
            $("#thumbnailSlider .owl-item").each(function(index){
                if(index==0 && $("#thumbnailSlider .owl-item").hasClass("active")){
                    
                    sliderThumb.trigger('next.owl.carousel');
                    sliderThumb.trigger('next.owl.carousel');
                    sliderThumb.trigger('next.owl.carousel');
                    sliderThumb.trigger('next.owl.carousel');
                }
            });
        }else{
            sliderThumb.trigger('prev.owl.carousel');
        }

        // sliderOverlay.trigger('prev.owl.carousel');
    }); 
    function activeGroupIndexLeft(){
        var itemCount = 0;
        var agi = false;
        $('#thumbnailSlider .owl-item').each(function(index){ 
            if ((index==0) && ($(this).hasClass("active"))){
                agi = true;
            }
        });
        return agi;
    }
    function activeGroupIndexRight(){
        var itemCount = 0;
        var agi = false;
        $('#thumbnailSlider .owl-item').each(function(index){ 
            if ((index+1==thisModelData.Photos.length) && ($(this).hasClass("active"))){
                agi = true;
            }
        });
        return agi;
    }
    
    var $window = $(window);
    var windowWidth = $window.width();
    // If the user scrolls down, hide sticky nav on mobile. Otherwise, show sticky nav on scroll up.
    if (windowWidth < 768) {
        $('html').on('DOMMouseScroll mousewheel', function(e) {
            if (e.originalEvent.detail > 0 || e.originalEvent.wheelDelta < 0) {
                //scroll down
                $(".acpv-header").addClass("hideme");
                $(".details-nav-wrapper").css("top", "0");
            } else {
                //scroll up
                $(".acpv-header").removeClass("hideme");
                $(".details-nav-wrapper").css("top", "50px");
            }
        });
    }
    // Top of page vehicle photo carousel
    $('.photos-carousel').owlCarousel({
        items: 1,
        loop: false,
        margin: 10,
        dotData: true
    });
    // Bottom of page similar vehicle carousel
    $('.similar-vehicle-carousel').owlCarousel({
        // loop: true,
        margin: 12,
        nav: false,
        dots: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            }
        }
    });
    //#region VDP Overlays
    //#region Contact Dealer  overlay
    var overlayContactElement = $('#inventory-details-contact');
    var overlayContact = new Overlay(overlayContactElement, {});
    $('#contact-dealer-button').css('cursor', 'pointer');

    window.openContactOverlay = openContactOverlay;
    $('#contact-dealer-button').click(function() {
        openContactOverlay();
    });
    $('#contact-dealer-button-bottom').click(function() {
        openContactOverlay();
    });
    $('#contact-dealer-btn-xs').click(function() {
        openContactOverlay();
    });

    function openContactOverlay() {
        $('[name=contact-error-api]').removeClass('contact-error-api').addClass('contact-error-api hidden');
        $('#form-dealer').removeClass('showForm hidden').addClass('showForm');
        $('#thankyou').attr('class', 'ty hidden');
        $('#firstname').val(''); 
        $('#lastname').val('');
        $('#email').val('');
        $('#call').val('');
        $('#textmessage').val('');
        $('#emailcontact').removeClass().addClass("unchecked");
        $('#callcontact').removeClass().addClass("unchecked");
        $('#textmessagecontact').removeClass().addClass("unchecked");
        $('#tradeinimage').removeClass().addClass("unchecked");
        $('#submitdisclaimer').removeClass().addClass("unchecked");
        $('#errpreferred').addClass("hidden");
        overlayContact.open();
        $('#inventory-details-contact').css('display', 'block');
        $('.overlay').css({ 'background-color': 'white' });
        $('.backdrop').css({ 'background-color': 'rgba(0,0,0,0.8)' });

        // tap call
        setTimeout(() => {
            if(typeof window.TapCallback === "function") {
                window.TapCallback({
                   "context": "inventory-contact-dealer-modal-load"
                });
             }
        }, 100);

    }
    $('.close-window').click(function() {
        reloadiFrame("overlay-iframe-video");
        overlayContact.close();
    });
    $('#contact-dealer-return-button').click(function() {
        overlayContact.close();
    });
    //#endregion
    //#region Calc Payment overlay
    var overlayCalcElement = $('#inventory-details-calculate');
    var overlayCalc = new Overlay(overlayCalcElement, {});
    $('#calculate-monthly-link').css('cursor', 'pointer');

    $('#calculate-monthly-link').on('click', function() {
        //pre set downpayment to 10%
        //$("#txt-downpayment").val('0');
        $("#txt-tradein").val('0');
        $(".errdownpayment").addClass("hidden");
        $("#div-tradein, #div-downpayment, #div-tradein").attr('style', 'border:0px;');
        $('[name=errtradein]').addClass('hidden');
        $("#txt-apr").trigger("click");
        //console.log('click-calculate-monthly-link');

        if (thisModelData.hasOffer == '1') {
            //console.log('link click- calculateMonthly()');
            //set apr textbox before re-calc. should be faster since it already set the hidden fields prior to clicking calc-monthly-link
            var a = thisModelData.offerApr;
            setCalcLayerControl(a);
            calculateMonthly(null);
        }
        overlayCalc.open();
        $('#inventory-details-calculate').css('display', 'block');

        $('.overlay').css({ 'background-color': 'white' });
        $('.backdrop').css({ 'background-color': 'rgba(0,0,0,0.8)' });

        callFloodlight('estimate-payments-results');
    });

    $('.close-window').click(function () {
        reloadiFrame("overlay-iframe-video");
        overlayCalc.close();
        
        if ($(this).hasClass('cmp') && $('[name=_hasoffer]').val() == '1') {
            $('.terms').children().removeClass("term-btn-active");
        }
        $('.overlay-backdrop').removeClass('backdrop-visible').addClass('backdrop-hidden');
        $('#inventory-details-calculate').css('display', 'none');
        $("#txt-apr").removeAttr("data-custom-apr");
    });
    //#endregion
    //#region Inventory Offer overlay
    var overlayOfferElement = $('.offer-details-overlay');
    var overlayOffer = new Overlay(overlayOfferElement, {});
    $('#offer-details-link').css('cursor', 'pointer');

    window.buyOnline = function buyOnline(e) {
        e.preventDefault();
        setTimeout(() => {
            if(typeof window.TapCallback === "function") {
                window.TapCallback({
                   "context": "inventory-buyonline-modal" //TODO: change context value if tagging requires it
                });
             }
        }, 500);
    };
    
    $('body').on('click', 'a.offer-short-details-link', function(e) {
        e.preventDefault();
        setOfferVDPOverlay();
        overlayOffer.open();
        $('.offer-details-overlay').removeClass('hideme');
        if(typeof window.TapCallback === "function") {
            window.TapCallback({
                "context": "inventory-offers_modal"
            });
        }
    });
    $('.close-window').click(function() {
        reloadiFrame("overlay-iframe-video");
        overlayOffer.close();
        $('.offer-details-overlay').addClass('hideme');
    });
    //#endregion
    //Vehicle gallery fullscreen
    var overlayElement = $('#inventory-details-fullpreview');
    var overlayGallery = new Overlay(overlayElement, {});
    $('.gallery-fullscreen').css('cursor', 'pointer');
    $('.close-window').click(function() {
        reloadiFrame("overlay-iframe-video");
        overlayGallery.close();
    });

    $('.gallery-fullscreen').click(function () {
        $('.overlay').css({ 'background-color': 'black' });
        $('.overlay').css({ 'margin-top': '0' });
        $('.overlay').css({ 'margin-bottom': '0' });
        $('.backdrop').css({ 'background-color': 'black' });
        overlayGallery.open();
        if(typeof window.TapCallback === "function") {
            window.TapCallback({
               "context": "inventory-gallery-modal"
            });
         }
        //onclick, reload the main video player to stop the video from playing
        //this is to prevent 2 voice overs playing at the same time
        reloadiFrame("main-iframe-video");
    });

    // Previous and next navigation
    $('.fullscreen-slider-right').click(function() {
        //reset iframe video
        reloadiFrame("overlay-iframe-video");
        //rpaik
        if(activeItemIndex()+1 == thisModelData.Photos.length){
            var indexCount = 0;
            $("#thumbnailSlider .owl-item").each(function(index){
                if(index==0){
                       $(this).trigger("click");
                }
            });
        }else{
            overlySlider.trigger('next.owl.carousel');
            vpdSlider.trigger('next.owl.carousel');    
        }
        
    });
    $('.fullscreen-slider-left').click(function() {
        //reset iframe video
        reloadiFrame("overlay-iframe-video");
        if(activeItemIndex()==0){
            var indexCount = 0;
            $("#thumbnailSlider .owl-item").each(function(index){
                if(index==thisModelData.Photos.length-1){
                    $(this).trigger("click");
                }
            });
        }else{
            overlySlider.trigger('prev.owl.carousel');
            vpdSlider.trigger('prev.owl.carousel');    
        }
        
    });
    //#endregion
    // this funciton is to reload the iframe to stop video from playing
    function reloadiFrame(playerID) {
        const player = document.getElementById(playerID)
        if (player) {
            player.src = player.src;
        }
    }
    
    //iFrame video tracking code
    function videoStart() {
        _satellite.track("vehdetails_gallery_videostart");
    }

    function videoCompleted() {
        _satellite.track("vehdetails_gallery_videocomplete");
    }

    window.addEventListener("message", receiveMessage, false);
    function receiveMessage(event) {
        if (event !== null && typeof event === 'object') {
            if (event.data !== null && typeof event.data === 'object') {
                if (event.data.provider !== null && event.data.provider === 'ifrmae-csi-mp') {
                    if (event.data.action == "media-started") videoStart();

                    if (event.data.action == "media-completed") videoCompleted();
                }
            }
        }
    }


    //#region Utility Top Bar 
    $('#savevehiclelink').click(function() {
        var vin = thisModelData.VIN;
        // console.log('vin', vin);
        if (window.acpv.SavedVehicles.has(vin)) {
            window.acpv.SavedVehicles.delete(vin);
            $('#savevehicleimage').attr('style', 'border-color:white');
        } else {
            console.log('seting saved vehicle');
            $('#savevehicleimage').attr('style', 'border-color:red');
            performSaveAnimation($("#savevehicleimage")[0], 'savedVehicleCount');
            // we store some information about the vehicle to show
            // when the vehicle has been sold
            window.acpv.SavedVehicles.set(vin, {
                mileage: thisModelData.Mileage,
                modelGroupName: thisModelData.ModelGroupName,
                modelYear: thisModelData.ModelYear,
                price: thisModelData.DSRP
            });
        }
            // check if compare/save bar is open and adjust contact dealer 
            checkBottomBar();
    });
    $('#savevehicleimage').click(function() {
        var vin = thisModelData.VIN;
        if (window.acpv.SavedVehicles.has(vin)) {
            window.acpv.SavedVehicles.delete(vin);
            $('#savevehicleimage').attr('style', 'border-color:white');
        } else {
            //console.log('seting saved vehicle');
            $('#savevehicleimage').attr('style', 'border-color:red');
            performSaveAnimation($("#savevehicleimage")[0], 'savedVehicleCount');
            window.acpv.SavedVehicles.set(vin, {
                mileage: thisModelData.Mileage,
                modelGroupName: thisModelData.ModelGroupName,
                modelYear: thisModelData.ModelYear,
                price: thisvin.DSRP
            }); //Dany to fetch vechiles every time compare vehicles is now hit
        }
            // check if compare/save bar is open and adjust contact dealer 
            checkBottomBar();
    });
    $('#comparevehicleimage').click(function() {
        var vin = thisModelData.VIN;
        if (window.acpv.CompareVehicles.has(vin)) {
            window.acpv.CompareVehicles.delete(vin);
            $("#comparevehicleimage").removeClass();
            $('#comparevehicleimage').addClass('unchecked');
        } else if (window.acpv.CompareVehicles.size < 3) {
            //console.log('seting compare vehicle');
            $("#comparevehicleimage").removeClass();
            $('#comparevehicleimage').addClass('checked');
            performSaveAnimation($("#comparevehicleimage")[0], 'compareVehicleCount');
            window.acpv.CompareVehicles.set(vin, 1);
        }
            // check if compare/save bar is open and adjust contact dealer 
            checkBottomBar();
    });
    $('#comparevehiclelink').click(function() {
        var vin = thisModelData.VIN;
        if (window.acpv.CompareVehicles.has(vin)) {
            // check if compare/save bar is open and adjust contact dealer
            window.acpv.CompareVehicles.delete(vin);
            $("#comparevehicleimage").removeClass();
            $('#comparevehicleimage').addClass('unchecked');
        } else if (window.acpv.CompareVehicles.size < 3) {
            // check if compare/save bar is open and adjust contact dealer
            //console.log('seting compare vehicle');
            $("#comparevehicleimage").removeClass();
            $('#comparevehicleimage').addClass('checked');
            performSaveAnimation($("#comparevehicleimage")[0], 'compareVehicleCount');
            window.acpv.CompareVehicles.set(vin, 1);
        }
            // check if compare/save bar is open and adjust contact dealer 
            checkBottomBar();        
    });

    //#endregion

    //#region Copy ClipboardJS
    /*
    *
    *  closeSharePopover() is used to close the popover
    *
    */

    // bootstrap popover function

    $("[data-toggle=popover]").popover({
        html: true,
        sanitize: false,
        content: function () {
            return $('#popover-content').html();
        },
        // container: '.details-nav'
    });

    $("[data-toggle=popover]").on('show.bs.popover', function () {
        if(typeof window.TapCallback === "function") {
            window.TapCallback({
               "context": "inventory-share-modal"
            });
         }
      })


    // init Clipboard plugin
    let shareClipboard = new ClipboardJS('#sharePopover', {
        text: () => window.location,


    });

    //after popover is open and visible, listen for click to change
    //the 'text' copy to a check mark
    $(document).on('click', '#share-btn', function (event) {
        var $shareBtn = $('.popover').find('#share-btn');
        if ($(".popover").is(":visible")) {
            $shareBtn.addClass('copied').text('');
            $('.popover').find('p').text('Link copied and ready to share.');
        }
    });


    // Bind resize event to popover 
    $(window).bind('resize', function () {
        if ($(".popover").length) {
            $("[data-toggle=popover]").popover('show');
        }
    });

    shareClipboard.on('success', function (e) {

        // $('.share-link-copy').addClass('copied');
        // console.info('Action:', e.action);
        // console.info('Text:', e.text);
        // console.info('Trigger:', e.trigger);
        // e.clearSelection();
        // $('.popover').addClass('popoverStyle');

        // $('.popover').css({ 'width': '100%', 'max-width': '100%', 'left': '0' });
        // $('.arrow').css('left', '80%');

        // let $window = $(window);
        // let windowWidth = $window.width();

        // if (windowWidth < 768) {
        //     $('.popover').css({ 'width': '300px', 'left': '-224px' });
        //     $('.arrow').css('left', '91%');
        // }
    });
    shareClipboard.on('error', function (e) {
        console.log('Clipboard : ', e);
    });
    //#endregion
    //#region Contact form
    $('[name=errfirstname]').removeClass('errMessage').addClass('errMessage hidden');
    $('[name=errlastname]').removeClass('errMessage').addClass('errMessage hidden');
    $('[name=errzip]').removeClass('errMessage').addClass('errMessage hidden');
    $('[name=errpreferred]').removeClass('errMessage').addClass('errMessage hidden');
    $('[name=contact-error-api]').removeClass('contact-error-api').addClass('contact-error-api hidden');
    $('[name=errapr]').removeClass('errMessage').addClass('errMessage hidden');
    $('[name=errdownpayment]').removeClass('errMessage').addClass('errMessage hidden');
    $('[name=calculate-api-err]').removeClass('calculate-api-err').addClass('calculate-api-err hidden');
    var stored_zip = ZipStorage.getZip();
    var zipdealer = stored_zip;
 
    // Make sure there is a zip code before updating the field
    if (zipdealer) {
        $('[name=zip]').val(zipdealer);
    }
    var $window = $(window);
    var windowWidth = $window.width();
    if (windowWidth < 790 && windowWidth > 768) {
        $('.trade-in').css({ 'padding-top': '6%' });
    }
    if (windowWidth < 768) {
        // $('.trade-in').css({ 'padding-top': '9%'});  //  $('.trade-in').css({ 'padding-top': '9%', 'left': '-224px' });
    }
    $('#emailcontact').click(function() {
        if ($('#emailcontact').hasClass('checked')) {
            // console.log('set to uncheck');
            $("#emailcontact").removeClass();
            $('#emailcontact').addClass('unchecked');
        } else {
            // console.log('set to check');
            $("#emailcontact").removeClass();
            $('#emailcontact').addClass('checked');
        }
    });
    $('#callcontact').click(function() {
        if ($('#callcontact').hasClass('checked')) {
            //console.log('set to uncheck');
            $("#callcontact").removeClass();
            $('#callcontact').addClass('unchecked');
        } else {
            //  console.log('set to check');
            $("#callcontact").removeClass();
            $('#callcontact').addClass('checked');
        }
    });
    $('#textmessagecontact').click(function() {
        if ($('#textmessagecontact').hasClass('checked')) {
            // console.log('set to uncheck');
            $("#textmessagecontact").removeClass();
            $('#textmessagecontact').addClass('unchecked');
        } else {
            // console.log('set to check');
            $("#textmessagecontact").removeClass();
            $('#textmessagecontact').addClass('checked');
        }
    });
    $('#tradeinimage').click(function() {
        if ($('#tradeinimage').hasClass('checked')) {
            // console.log('set to uncheck');
            $("#tradeinimage").removeClass();
            $('#tradeinimage').addClass('unchecked');
        } else {
            //  console.log('set to check');
            $("#tradeinimage").removeClass();
            $('#tradeinimage').addClass('checked');
        }
    });
    $('#submitdisclaimer').click(function() {
        if ($('#submitdisclaimer').hasClass('checked')) {
            // console.log('set to uncheck');
            $("#submitdisclaimer").removeClass();
            $('#submitdisclaimer').addClass('unchecked');
        } else {
            //  console.log('set to check');
            $("#submitdisclaimer").removeClass();
            $('#submitdisclaimer').addClass('checked');
            $('#privacypolicy').css('color', '#888');
        }
    });
    //#region scrolling VDP page 


    function Utils() {

    }

    Utils.prototype = {
        constructor: Utils,
        isElementInView: function(element, fullyInView) {
            var pageTop = $(window).scrollTop() - 10;
            var pageBottom = pageTop + $(window).height();
            var elementTop = $(element).offset().top;
            var elementBottom = elementTop + $(element).height();
            if (fullyInView === true) {
                return ((pageTop < elementTop) && (pageBottom > elementBottom));
            } else {
                return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
            }
        }
    };
    var Utils = new Utils();
    $(window).scroll(function() {
        //contact-dealer-button  veh_info_div
        //console.log('inside scrolling contact-dealer...');
        var veh_info = $('#contact-dealer-button');
        //console.log('veh_info:', veh_info.length);
        var isElementInView = Utils.isElementInView(veh_info, false);
        if (isElementInView) {
            //console.log('in view');
            $('#contact-dealer-button-bottom').removeClass().addClass("button-1-fade hidden");
        } else {
            // console.log('out of view');
            $('#contact-dealer-button-bottom').removeClass().addClass("button-1-fade");
        }
    });
    //#endregion
    $('#contactform').submit(function(e) {
        if (checkForm()) {
            var host = document.location.hostname;
            var fname = $('input[name="firstname"]').val();
            var lname = $('input[name="lastname"]').val();
            var zipcode = $('input[name="zip"]').val();
            var _email = $('input[name="email"]').val();
            var _callnumber = $('input[name="phone"]').val();
            var _textnumber = $('input[name="text"]').val();
            var _notes = $('input[name="notes"]').val();
            var _tradein = $('input[name="chktradein"]').is(':checked');
            var _image = thisModelData.VehicleImage;
            var _dealrID = thisModelData.DealerID;
            var _extColor = thisModelData.ModelExteriorColorCD;
            var _intColor = thisModelData.ModelInteriorColorCD;
            var _transmission = thisModelData.ModelTransmission;
            var _hp = $('input[name="phone"]').val();
            var _ishp = $('#ph').hasClass("active");
            var _cell = $('input[name="text"]').val();
            var _iscell = $('#tx').hasClass("active");
            /*
            * SaleType is used for Provider (Leads)
            * Possible values 'BT', 'CPO' and 'USED'
            * Based on Vehicle type (ex. Acura Precision Used)
            */ 
            var saletype = thisModelData.VehicleType === "C" ? thisModelData.CPOTier === "BT" ? "BT" : "CPO" : "USED";

            //if ($('#textmessagecontact').hasClass("checked")
            //#callcontact
            //#textmessagecontact
            //HomePhone
            //Is Home Phone
            //Cell number
            //Is cell 
            //get _CampaignName from cookies
            if (Cookies.get('_CampaignName')) {
                var CampaignName = Cookies.get('_CampaignName');
            }
            var dealerRequest = {
                "FirstName": fname,
                "LastName": lname,
                "ZipCode": zipcode,
                "Email": _email,
                "HomePhone": _hp,
                "IsHomePhone": _ishp,
                "Cellnumber": _cell,
                "IsCell": _iscell,
                "ModelYear": thisModelData.ModelYear,
                "ModelMake": "Acura",
                "ModelName": thisModelData.ModelGroupName,
                "ModelMarketingName": (thisModelData.ModelMarketingName == "" ? " " : thisModelData.ModelMarketingName),
                "SaleType": saletype,
                "DealerName": thisModelData.DealerName,
                "DealerAddress": thisModelData.DealerAddress + " " + thisModelData.DealerCity + " " + thisModelData.DealerState + " " + thisModelData.DealerZip,
                "DealerPhone": thisModelData.DealerPhoneNumber,
                "VehicleImage": _image,
                "ModelTrim": thisModelData.ModelTrim,
                "ModelPrice": Number(thisvin.DSRP).toLocaleString('en-US'),
                "DrivingDistance": thisModelData.SingleOwner,
                "Model": {
                    "modelId": thisModelData.ModelId,
                    "modelGroupName": null,
                    "modelYearStart": 0,
                    "modelYearEnd": 0,
                    "modelExteriorColorCd": _extColor,
                    "modelInteriorColorCd": _intColor,
                    "modelPriceLimit": 0,
                    "modelTransmission": null,
                    "modelVin": thisModelData.VIN,
                    "modelMileage": thisModelData.Mileage,
                    "modelDealerStockNumber": thisModelData.StockNo,
                    "ModelConfiguredDSRP": thisModelData.DSRP
                },
                "Tracking": {
                    "CampaignName": CampaignName,
                    "ShoppingTool": "Inventory - Detail Page",
                },
                "Dealer": {
                    "dealerId": thisModelData.DealerID
                },
                "CarToTradeIn": _tradein
            }
            $('.contact-dealer-btn .contact-dealer-submit-btn').addClass('disabled');
            $('.spinner').show();
            // console.log('dealerRequest data: ', dealerRequest);
            var posturl = "/api/contact/dealer";

            $.post(posturl, { dealerRequest: JSON.stringify(dealerRequest) }, function (data) {
                 //console.log('https://acuracertifieddev.rpa-dev.com/api/contact/dealer:', data);
                data = JSON.parse(data);
                data = data.Output;
                if (data.Results.Status.toLowerCase() == "submitted") {
                    // console.log("contact dealer submitted!")
                    $('#distancetodealer_span4 a').attr('data-tap-element-id','cad_complete_dealer_website');
                    $('#form-dealer').removeClass('showForm').addClass('showForm hidden');
                    $('#thankyou').attr('class', 'ty');
                    if(typeof window.TapCallback === "function") {
                        window.TapCallback({
                           "context": "inventory-contact-dealer-modal-complete"
                        });
                     }

                    _satellite.track("vehdetails_dealer_contact_submit");
                    $('.spinner').hide();
                    $('.contact-dealer-btn .contact-dealer-submit-btn').removeClass('disabled');
                } else {
                    console.log(data, "contact dealer not  submitted!")
                    $('#form-dealer').removeClass('showForm').addClass('showForm hidden');
                    $('[name=contact-error-api]').removeClass('contact-error-api hidden').addClass('contact-error-api');
                    $('.spinner').hide();
                    $('.contact-dealer-btn .contact-dealer-submit-btn').removeClass('disabled');
                }
            });
            //$('.spinner').hide();
            e.preventDefault();
        }
        e.preventDefault();
    });
    //#endregion
    // $('#livechat').on('click', function(e) {
    //     // console.log('livechat');
    //     showContactOncePopup('chat');
    //     e.preventDefault();
    // });
    // $('#sendtext').on('click', function(e) {
    //     // console.log('livechat');
    //     showContactOncePopup('text');
    //     e.preventDefault();
    // });
    // $('#sendtext2').on('click', function(e) {
    //     // console.log('livechat');
    //     showContactOncePopup('text');
    //     e.preventDefault();
        
    // });
    //console.log('[name=_vin]');
    // console.log('name=_vin', $('[name=_vin]').val());
    //#region Document startup functions

    if (thisModelData.Photos_Count == "1") {
        //hide nav controls in VDP slider
        $('[name=photo-counter]').removeClass().addClass('cp-8 photo-counter hidden');
        $('[name=gallery-fullscreen]').removeClass().addClass('gallery-fullscreen hidden');
    }
    var title_max_copare = "You may only compare up to three vehicles.";
    var vin = thisModelData.VIN;
    //check compare checkbox and compare link
    if (window.acpv.CompareVehicles.has(vin)) {
        $('checkbox').addClass('checked');
        $("#comp").css('cursor', 'pointer');
        $("#comparevehicleimage").attr('title', "");
    } else if (window.acpv.CompareVehicles.size >= 3) {
        $('checkbox').addClass('disabled');
        $('#comp').attr('disabled', 'disabled');
        $("#comparevehicleimage").attr('title', title_max_copare);
        $("#comparevehiclelink").attr('title', title_max_copare);
        $("#comp").css('cursor', 'not-allowed');
        $("#comparevehiclelink").css('cursor', 'not-allowed');
    }
    //check save checkbox and compare link
    if (window.acpv.SavedVehicles.has(vin)) {
        // console.log('saved vin:', vin);
        $('#savevehicleimage').css({ "border-color": "red" })
    }
    //#endregion

    function validateNumberCurrencyFormat(e) {
        const value = e.target.value.replace(/\,/g,'');
        e.target.value = Number.isNaN(Number(value)) ? '0' : Number(value).toLocaleString();
    }

    $(document).ajaxStop(function() {
        // console.log('ajaxStop**********************');
        //Offers 
        showOffersVDP();
        setOfferTitleCalcLayer();
        //show calc link
        $('.calculate-monthly').removeClass('hidden');
        $('.spinner').hide();
    });
    //#region Calculator Controls JS Functions
    //calc control
    $("#txt-apr").blur(function() {
        // console.log('val', $(this).val())
       if ($(this).val() == previousAPR) return;
       $(this).attr("data-custom-apr", $(this).val());

        var aprvalue = 20; //must not exceed 20%
        if (checkAPR($(this).val(), aprvalue)) {
            // console.log('inside checkAPR', $(this).val());
            //set apr, downpayment, kbb textboxes
            setCalcLayerControl($(this).val());
            // re-calc needed after change in txt-apr
            var carvalue = thisvin.DSRP;
            var trade_val = $("#txt-tradein").val();
            if (checkTradeinValue(trade_val, '#txt-tradein', carvalue, '#div-tradein')) {
                // console.log('blurred - calculateMonthly **********************');
                calculateMonthly(1);
            }
        }
    });
    $('#txt-apr').on('keypress', function(e) {
        if (e.which === 13) {
            if ($(this).val() == previousAPR) return;
            $(this).attr("data-custom-apr", $(this).val());

            var aprvalue = 20; //must not exceed 20%
            if (checkAPR($(this).val(), aprvalue)) {
                // console.log('inside checkAPR', $(this).val());
                //re-calc 
                var carvalue = thisvin.DSRP;
                var trade_val = $("#txt-tradein").val();
                if (checkTradeinValue(trade_val, '#txt-tradein', carvalue, '#div-tradein')) {
                    calculateMonthly(1);
                }
            }
            $("#txt-downpayment").focus();
        }
    });

    $("#txt-downpayment, #txt-tradein")
        .focus(function () {
            clearZero($(this));
        });

    $('#txt-downpayment').on('keypress', function (e) {
        if (e.which === 13) {
            var carvalue = thisvin.DSRP //downpayment must not exceed carvalue
            // console.log('[name=_dsrp]');
            // console.log(carvalue);
            if (checkDownpayment($(this).val(), carvalue, '#txt-downpayment', '#div-downpayment')) {
                calculateMonthly(1);
            }
            $("#txt-tradein").focus();
        }
    });
    $("#txt-downpayment").blur(function(e) {
        // console.log('txt-downpayment blur:', $(this).val());
        var carvalue = thisvin.DSRP; //downpayment must not exceed carvalue
        // console.log('[name=_dsrp]');
        // console.log(carvalue);
        if (checkDownpayment($(this).val(), carvalue, '#txt-downpayment', '#div-downpayment')) {
            calculateMonthly(1);
        }
        validateNumberCurrencyFormat(e);
    });
    $("#txt-downpayment").click(function() {
        clearErrorDownpayment(this);
    });
    $('#txt-tradein').click(function() {
        clearErrorTradein(this);
    });
    $('#txt-tradein').on('keypress', function(e) {
        if (e.which === 13) {
            var carvalue = thisvin.DSRP;
            if (checkTradeinValue($(this).val(), '#txt-tradein', carvalue, '#div-tradein')) {
                calculateMonthly(1);
            }
            $("#txt-apr").focus();
        }
    });
    $("#txt-tradein").blur(function(e) {
        // console.log($(this).val());
        validateNumberCurrencyFormat(e);
        var carvalue = thisvin.DSRP; //downpayment must not exceed carvalue
        if (checkTradeinValue($(this).val(), '#txt-tradein', carvalue, '#div-tradein')) {
            calculateMonthly(1);
        }
    });
    $('.term-btn').click(function() {
        var btntext = $(this).text();
        $('.term-btn').each(function(index, obj) {
            if (btntext != $(this).text()) {
                $(this).removeClass('term-btn term-btn-active').addClass('term-btn');
            }
        });
        $(this).toggleClass('term-btn-active');
        var apr_text = $("#txt-apr").val();
        //set apr, downpayment, kbb textboxes
        //if (btntext == '24' || btntext == '36') {
        //    apr_text = '0.9'
        //} else if (btntext == '48' || btntext == '60') {
        //    apr_text = '1.9'
        //} else
        //   { apr_text = '4.04'}

        // if (btntext == '66' || btntext == '72') {
        //     apr_text = $('#txt-apr').attr('data-api-apr');
        // }

        setCalcLayerControl(apr_text);
        //re-calc after change in term
        var carvalue = thisvin.DSRP;
        var trade_val = $("#txt-tradein").val();
        if (checkTradeinValue(trade_val, '#txt-tradein', carvalue, '#div-tradein')) {
            calculateMonthly(1, true);
        }
    });
    $('.calculate-btn').click(function() {
        $(this).toggleClass('calculate-btn-active');
        var btntext = $(this).text();
        $('.calculate-btn').each(function(index, obj) {
            if (btntext != $(this).text()) {
                $(this).removeClass('calculate-btn calculate-btn-active').addClass('calculate-btn');
            }
        });
        calculateMonthly(1);
    });
    $("#txt-apr").click(function() {
        previousAPR = $(this).val();
        clearErrorAPR(this);
    });
    $('#lease-btn').click(function() {
        if ($('#finance-btn').hasClass('calculate-btn-active')) {
            $('#finance-btn').removeClass('calculate-btn calculate-btn-active').addClass('calculate-btn');
        } else {
            $(this).removeClass('calculate-btn').addClass('calculate-btn calculate-btn-active');
        }
    });

    //OWL item click, reload video iFrame to stop the video from playing
    $('.item').click(function () {
        reloadiFrame("main-iframe-video");
    });
       
    //This funtion is used to check for http/https
    // Dealer Website/URL
    var dealerUrlHidden = thisModelData.DealerURL;
    RedirectDealerURL(dealerUrlHidden);
    function RedirectDealerURL(DealerURL) {
        if (!DealerURL) {
            return '';
        }
        var newURL;
        // check if URL is http or https
        // First: handle http
        if (DealerURL.indexOf('https') < 0) {
            newURL = 'http://' + window.location.hostname + '/redirect.html?ref=' + DealerURL
            $('.dealer-website').attr('href', newURL);
        }
    }

    //#endregion
    // document.ready END
});

var calcOpen = function () {
    if(typeof window.TapCallback === "function") {
        window.TapCallback({
           "context": "inventory-calculate-modal"
        });
     }
    var overlayCalcElement = $('#inventory-details-calculate');
    var overlayCalc = new Overlay(overlayCalcElement, {});
        //pre set downpayment to 10%
        //$("#txt-downpayment").val('0');
        const tradeIn = Number(sessionStorage.getItem('acpv.inventory.tradein')).toLocaleString() || 0;
        $("#txt-tradein").val(tradeIn);
        $(".errdownpayment").addClass("hidden");
        $("#div-tradein, #div-downpayment, #div-tradein").attr('style', 'border:0px;');
        $('[name=errtradein]').addClass('hidden');
        $("#txt-apr").trigger("click");


        if (thisModelData.hasOffer == '1') {
            //set apr textbox before re-calc. should be faster since it already set the hidden fields prior to clicking calc-monthly-link
            var a = thisModelData.offerApr;
            setCalcLayerControl(a);

            const offerString = $('input[name="radio-offers-group"]:checked').val();
            if(offerString) {
                var offerSelected = JSON.parse(offerString);
                var APR = offerSelected.APR;
                var termMax = offerSelected.TermMax;
                $('#txt-apr').val(`${APR}%`);
                calculateMonthly({apr: APR, term: termMax});
            }else {
                calculateMonthly(null);
            }
        }
        overlayCalc.open();
        $('#inventory-details-calculate').css('display', 'block');

        $('.overlay').css({ 'background-color': 'white' });
        $('.backdrop').css({ 'background-color': 'rgba(0,0,0,0.8)' });

        callFloodlight('estimate-payments-results');
}

var getFeature = function() {
    $.ajax({
        url: dataURL + '/api/Features/keyFeatures',
        type: 'get',
        async: false,
        data: {
            modelid: thisModelData.ModelId
        },
        dataType: "json",
        complete: function complete(data, status) {
            if (status == 200) {
                console.log('getFeature complete. no return result');
            }
        },
        success: function success(result) {
            setFeature(result);
        },
        error: function error(jqXHR, textStatus, errorThrown) {
            // console.log("failed ajax call - getFeature");
            return null;
        }

    });
} 


var setAltPhoto = function(result) {
    var noImageContent = '<div class="item">';
     noImageContent += '    <div class="content">';
     noImageContent += '        <img src="' + result + '" border="0" alt="">';
     noImageContent += '    </div>';
     noImageContent += '</div>';    
     thisModelData.VehicleImage = result;
     $('.vehicle-img-wrapper img').attr('src',result);
     $('#vehicle-details-wrapper #slider').html(noImageContent);
     $('#vehicle-details-wrapper #slider').show();
 }

 var getAltPhoto = function() {
    $.ajax({
        //url: 'https://acuracertifieddev.rpa-dev.com/api/Inventory/getAltVehiclePhoto',
        url: dataURL + '/api/Inventory/getAltVehiclePhoto',
        type: 'get',
        async: false,
        data: {
            vin: thisvin.VIN,
            zip: thisDealer.DealerZip
        },
        dataType: "text",
        complete: function complete(data, status) {
            if (status == 200) {
                console.log('getFeature complete. no return result');
            }
        },
        success: function success(result) {
              setAltPhoto(result);
        },
        error: function error(jqXHR, textStatus, errorThrown) {
            console.log('get alt photo failed')
            return null;
        }

    });
} 

var getVehicleDetails = function () {
    $.ajax({
        url: dataURL + '/api/Inventory/GetVehicleDetails',
        type: 'get',
        async: true,
        data: {
            vin: getUrlVars()["vin"]
        },
        dataType: "json",
        complete: function complete(data, status) {
            if (status == 200) {
                console.log('getVehicleDetails complete. no return result');
            }
        },
        success: function success(result) {
            //console.log('ok ajx result - getVehicleDealerObject');   //Output - Results - MonthlyPayment 
            //console.log(result);
            if (result.Output.Results.Models == null) {
                $('.error-pages').removeClass('hidden')
            } else {
                setVehicleDetail(result);
                $('.acpv-main.content').removeClass('hidden');

                //get defaultAPR
                $.ajax({
                    url: dataURL + '/api/calculators/ComputeFinancePayment',
                    type: 'get',
                    data: {
                        apr: '',
                        term: '',
                        msrp: thisvin.DSRP,
                        downpayment: 0,
                        TradeInValue: 0,
                        modelid: thisModelData.ModelId
                    },
                    dataType: "json",
                    success: function(result) {
                        thisDefaultAPR = result.APR;
                        const defaultValue = JSON.stringify({APR: thisDefaultAPR, TermMax: result.Term});
                        $('.vdp-offers .form-group').append(`<div>
                            <radio><input class="radio-offer" type="radio" id="no_offer" name="radio-offers-group" value=${defaultValue}></radio>
                            <label for="no_offer">No offer</label>
                        </div>`);
                    }
                });
            }

            return result;
        },
        error: function error(jqXHR, textStatus, errorThrown) {
            // console.log("failed ajax call - getSimilarVehicles");
            $('.error-pages').removeClass('hidden')
            return null;
        }

    });
}

var getUrlVars = function()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}




var  formatDealerhours = function(dhours)
{
        //orig format: Mon-Thu 9:00AM-9:00PM;Fri-Sat 9:00AM-6:00PM;Sun Closed
        // dhours = "Mon-Thu 9:00AM-9:00PM;Fri-Sat 9:00AM-6:00PM;Sun Closed";
        // dhours = "Mon-Sat 9:00AM-8:00PM;Sun Closed";

        var days = dhours.split(';');
        var dealerhour = [];
        var times = [];

        for (var d = 0; d < days.length; d++)
        {
            times = days[d].split(' ');
            var p = {
                day: times[0],
                time: times[1]
            }
            dealerhour.push(p);
        }
         return dealerhour;
}

















// close copy/share popover
function closeSharePopover() {
    $("[data-toggle=popover]").popover('hide');
    //click to focus on share link
    $('#sharePopover').click();

    //reser check mark
    $('.share-link-copy').removeClass('copied');

}

$(document).on("scroll", "bottom-bar", function () {
    // console.log("Clicked.");
});
// contact dealer CTA make it sticky
var fixed = true;
$(window).on('scroll', function(e) {
    var scrollTop = $(this).scrollTop(),
        elementOffset = $('#contact-btn-wrapper').offset().top,
        elementOffsetFooter = $('.acpv-footer').offset().top,
        distanceCTA = (elementOffset - scrollTop),
        distanceFooter = (elementOffsetFooter - scrollTop),
        distanceFromBottom = $(document).height() - ($(document).scrollTop() + $(window).height()),
        footerHeight = $('.acpv-footer').height(),
        vin = thisModelData.VIN;

   

    // console.log('distanceCTA: ', distanceCTA)
    // console.log('distanceFromBottom: ', distanceFromBottom)
    if ((distanceCTA > distanceFooter) && !(this.oldScroll > this.scrollY)) {
        if (fixed) {
            fixed = false;
            // console.log('----- >  scroll is: ', this.oldScroll > this.scrollY)
            $('#contact-btn-wrapper').removeClass("fixed-cta");
        }
    }
    if ((this.oldScroll > this.scrollY) && (!fixed)) {
        if (distanceFromBottom >= footerHeight) {
            fixed = true;
            $('#contact-btn-wrapper').addClass("fixed-cta");
        }
    }
    // check if compare/save bar is open
    checkBottomBar();
    // print "false" if direction is down and "true" if up
    // console.log(this.oldScroll > this.scrollY);
    //get scroll detection
    this.oldScroll = this.scrollY;
});
// check if compare/save bar is open
function checkBottomBar() {
    setTimeout(function() {
        var saveBar = window.acpv.SavedVehicles.has(thisModelData.VIN);
        var compareBar = window.acpv.CompareVehicles.has(thisModelData.VIN);
        //move contact dealer based on the conditions
        if (saveBar || compareBar) {
            $('#contact-btn-wrapper').css('bottom', '60px');

            //sticky bar
            $('bottom-bar .stickycompare').attr('data-tap-element-id','stickybar_compare');
            $('bottom-bar .stickysave').attr('data-tap-element-id','stickybar_save');
            $('bottom-bar #contact-dealer-button-bottom').attr('data-tap-element-id','stickybar_contact');
        } else {
            $('#contact-btn-wrapper').css('bottom', '0');
        }
    }, 500);
}
//#region ContactOnce and Other JS functions
// function showContactOncePopup(option) {
//     var dealerId = $('[name=_dealerid]').val();
    
//     if (option == 'chat') {
//         var chatEngConfiguration = {
//             "referenceId": dealerId,
//             "engagementId": 1,
//             "channel": "chat"
//         };
//         lpTag.sdk.exec("caoEngager.startChat", chatEngConfiguration);

//         // Old code 
//        // javascript: window.open('https://honda.contactatonce.com/caoclientcontainer.aspx?ProviderId=1587&MerchantId=' + dealerId + '&PlacementId=1&ZipCode=xxxxx&OriginationUrl=' + encodeURIComponent(location.href), '', 'resizable =yes,toolbar=no,menubar=no,location=no,scrollbars=no,status=no,height=400,width=600');
//         callFloodlight('dealer-chat');
//          return false;
//     }
//     if (option == 'text') {
//         var mtcPropertiesErrorCallback = function (data) {
//             console.log('Error retrieving mtc property data for referenceId:' + referenceId);
//         };

//         var mtcPropertiesSuccessCallback = function (data) {
//             var mtcEngConfiguration = {
//                 "referenceId": dealerId,
//                 "engagementId": 1,
//                 "channel": "mtc",
//                 "mtc": data.properties
//             };
//             if (mtcEngConfiguration.mtc.phoneNumber) {
//                     lpTag.sdk.exec("caoEngager.startChat",  mtcEngConfiguration);
//             }
//         };
//         lpTag.sdk.exec("caoEngager.getMtcProperties", {
//             referenceId: dealerId,
//             onSuccess: mtcPropertiesSuccessCallback,
//             onError: mtcPropertiesErrorCallback
//         });

//         // Old code
//         // javascript: window.open('https://mtc.contactatonce.com/MobileTextConnectConversationInitiater.aspx?AdvertiserId=' + dealerId + '&ProviderId=1587&PlacementId=1&ZipCode=xxxxx&Message=Hi%2C%20I%20have%20a%20question%20about%20Acura&OriginationUrl=' + encodeURIComponent(location.href), '', 'resizable=yes,toolbar=no,menubar=no,location=no,scrollbars=no,status=no,height=350,width=410');
//         callFloodlight('dealer-chat');
//         return false;
//     }
 
// }
//function to check if chat in Online
// function getContactOnceStatus() {
//     var dealerId = $('[name=_dealerid]').val();
//     var status = false;

//     function presenceCallback(presenceData) {
//         if (presenceData.presenceStatus === 'online') {
//             console.log('Chat is online');
//             status = true;
//         } else {
//             console.log('Chat is offline');
//             $('.live-chat-wrapper').addClass('hidden');
//             $('.text-wrapper').addClass('hidden');
//         }
//     }
//     function presenceErrorCallback() {
//         console.log("Error checking Contact At Once presence");
//     }
//     var presenceReq = {
//         "referenceId": dealerId,
//         "engagementId": 1,
//         "onSuccess": presenceCallback,
//         "onError": presenceErrorCallback
//     };
//     lpTag.sdk.exec("caoPresence.getPresence", presenceReq);
//     return status;
// }

function getDistanceFromDealer() {
    // console.log('ajaxCall get-getDistanctFromDealer');
    // http://acuracertified/api/dealerlocator/finddealersonly?zip=90404&radius=250
    
    // get user zip code from local storage 
    var localStorageZip = ZipStorage.getZip();
    var _zip;
    //if there is no zip in local storage, use dealer zip
    if (localStorageZip){
        _zip = localStorageZip
    } else {
        _zip = thisModelData.DealerZip;
    }
    var _rad = 250;
    _zip = _zip.substring(0, 5);
    // console.log('_zip', _zip);
    // console.log('_rad', _rad);
    $.ajax({
        type: 'get',
        dataType: "json",
        url: '/api/dealerlocator/finddealersonly',
        data: {
            zip: _zip,
            radius: _rad
        },
        success: function (result) {
            // console.log('ok ajax result - getDistanctFromDealer');   //Output - Results - MonthlyPayment  
            //console.log('result',result["POIResponse"]["POIs"]["POI"][0]);
            //get the hidden value of the dealer ID
            var dealerId = thisModelData.DealerID;
            var results = result["POIResponse"]["POIs"]["POI"];
            if (thisDealer.DealerURL == 'null') {
                thisDealer.DealerURL = '#';
            }
            for (var i = 0; i < results.length; i++) {
                if (result["POIResponse"]["POIs"]["POI"][i] != null) {
                    //only find the matching dealer ID
                    if (result["POIResponse"]["POIs"]["POI"][i]["POIId"] == dealerId) {
                        $('#distancetodealer_link2').html(result["POIResponse"]["POIs"]["POI"][i]["Distance"] + ' away ');
                        $('#distancetodealer_link3').html(result["POIResponse"]["POIs"]["POI"][i]["Distance"]);
                        $('#distancetodealer_span').html(result["POIResponse"]["POIs"]["POI"][i]["Distance"] + ' away at ' + '<a href="'+ thisDealer.DealerURL +'" target="_black" data-tap-element-id="vpd_hero_dealer_website">' + thisDealer.DealerName + '</a>');
                        $('#distancetodealer_span2').html(result["POIResponse"]["POIs"]["POI"][i]["Distance"]);
                        $('#distancetodealer_span3').html(result["POIResponse"]["POIs"]["POI"][i]["Distance"] + '<div>' + '<a style="margin-left:0px;font-weight:bold;" href="'+ thisDealer.DealerURL +'" target="_black" data-tap-element-id="calulate_dealer_website">' + thisDealer.DealerName + '</a></div>');
                        $('#distancetodealer_span4').html(result["POIResponse"]["POIs"]["POI"][i]["Distance"] + ' away from ' + '<a href="'+ thisDealer.DealerURL +'" target="_black" data-tap-element-id="cad_form_dealer_website">' + thisDealer.DealerName + '</a>');
                        thisModelData.SingleOwner = result["POIResponse"]["POIs"]["POI"][i]["DrivingDistance"];
                        vdpWrapper.attr('data-tap-dealer-distance',result["POIResponse"]["POIs"]["POI"][i]["Distance"]);
                    }
                } else {
                    $('.spinner').hide();
                    $('#similarvehicles').addClass('hidden');
                }
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            // since ajax call failed, ask user to input location
            //  console.log('error result getDistanctFromDealer', jqXHR); 
            $('#distancetodealer').html('');
        }
    });
}
//#endregion
//#region Offers JS Functions
function performSaveAnimation(element, elementId) {
    var bottomBar = $('bottom-bar');
    if (bottomBar.length === 0) {
        return;
    }

    var offset = { x: 0, y: 0 };
    var bottomBarController = bottomBar.data('controller');
    if (bottomBarController.isClosed()) {
        offset.y = -bottomBarController.content.height();
    }
    new window.SaveAnimation({
        element: element,
        offset: offset,
        toElementId: elementId
    });
}
//getOffersFromApi -TODO: verify, check and cleanup 
function getOffersFromApi() {
    //var url = 'api/calculators/ComputeFinancePayment?apr=5&term=36&msrp=26000&downpayment=1000&TradeInValue=1000&modelid=DE2F3HJW';
    var url = 'public/data/test-offers.json';
    $.ajax({
        url: url,
        type: 'get',
        dataType: "json",
        complete: function (data, status) {
            if (status == 200) {

            }
        },
        success: function(result) {
            // console.log("success getOffersFromApi");
            //console.log('result:', result);
            var mid = thisModelData.ModelId
            if (checkOfferModelId(mid, result)) {
                // console.log("model id in Offers json");
                $('.offer-details').removeClass('hidden');
            } else {
                console.log("model id NOT in Offers json");
            }
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.log("getOffersFromApi: did not work");
        }
    });
}

function checkOfferModelId(mid, data) {
    try {
        // console.log("inside checkOfferModelId");
        var modelsData = data['HOT']['MOTs']['MOT']['Output']['Results']['Specials']['Special'][0]['ApplicableModels']['Model'];
        // console.log('modelData:', modelsData);
        // console.log('modelID:', mid);
        var retVal = false;
        $.each(modelsData, function(i, v) {
            if (v.ModelID == mid) {
                // found it...
                // console.log('modelID found it...');
                retVal = true; // stops the loop
            }
        });
        // console.log('modelID is found ? ', retVal);
        return retVal;

    }
    catch (error) {
        console.log("error checkOfferModelId:", error);
        return false;
    }
}

function setOfferFieldValues(_apr, _term, _shortdesc, _shortdisclaimer, _lowapr, _lowterm) {
    thisModelData.hasOffer = '1';
    thisModelData.maxTerm = '0'; //0=false, user hasnt clicked on a term thats not part of an offer
    thisModelData.hasOfferTitle = 'Apply ' + _apr + '% APR for ' + _term + ' months offer?';
    thisModelData.isOfferApplied  ='with ' + _apr + '% APR for ' + _term + ' months offer applied';
    thisModelData.offerApr = _apr;
    thisModelData.offerTerm = _term;
    thisModelData.offerDisclaimer = _shortdisclaimer;
    thisModelData.offerDescription = _shortdesc;
    thisModelData.offerAprVdp = _apr;
    thisModelData.offerTermVdp = _term;
}

function setOfferFieldsOff() {
    thisModelData.hasOffer = '0';
}

function showOffersVDP() {
    if (thisModelData.hasOffer != '1') {
        // console.log('showoffersVDP: no offers here. CalcMonthly API might still be loading ');
        //no offers, return function
        return;
    }
    // console.log("showOffersVDP:", $('[name=_hasoffer]').val());
    $('.offer-details').removeClass('hidden');
    var apr, term, shortdesc, shortdisclaimer;
    apr = thisModelData.offerApr;
    term = thisModelData.offerTermVdp;
    // console.log("apr showOffersVDP ****", apr);
    // console.log("term showOffersVDP ***", term);
    var class_desk = '<div class="offers-terms">';
    var class_mobile = '<div class="offers-terms-mobile">';
    var class_term = '';
    var $window = $(window);
    var windowWidth = $window.width();
    if (windowWidth < 768) {
        class_term = class_mobile
    } else {
        class_term = class_desk
    }
    //desktop
    var data_desk = '<div class="header-copy text-center"><h10 class="hl-10">FINANCE OFFER</h10><hr /></div>';
    data_desk = data_desk + class_term;
    data_desk = data_desk + '<ul><li class="apr-copy cp-3">' + apr + '% APR up to ' + term + ' months </li>';
    data_desk = data_desk + '</ul></div><div class="offer-short-details"><div class="offer-short-details-copy"><p>For well qualified buyers. <a class="offer-short-details-link" href id="offer-details-link" data-tap-element-id="vpd_offer_details">Details</a></p>'
    data_desk = data_desk + '</div></div>';
    $('.offer-details').html(data_desk);
}

function setOfferTitleCalcLayer() {
    if (thisModelData.hasOffer != '1' || thisModelData.maxTerm == '1') {
        toggleOfferTitleCalcLayer(0);
        return;
    }
    var title = thisModelData.isOfferApplied
    var data = '<span class="cp-5">' + title + '</span>';
    var disp_offer = thisModelData.hasOfferTitle;
    var disp_data = '<span class="cp-5"><a href="#" class="invite-offer" onclick="applyOffer()">' + disp_offer + '</a></span>';
    var apr = thisModelData.offerApr;
    var term = thisModelData.offerTerm;
    var _apr = $('#txt-apr').val().replace(/\%/g, '');
    var _term = '';
    $('.term-btn').each(function(index, obj) {
        if ($(this).hasClass('term-btn-active')) {
            _term = $(this).text()
        }
    });
    toggleOfferTitleCalcLayer(1);
    // if (apr == _apr && term == _term) {
    if (apr == _apr && term == _term) { //term usually is flexible, apr is !important
        //check term and apr   
        $('.offer').html(data);
    } else if (apr != _apr || term != _term) {
        $('.offer').html(disp_data);
    }
}

function toggleOfferTitleCalcLayer(val) {
    var vehicleType = thisModelData.VehicleType;
    const cpoTier = thisModelData.CPOTier;
    // hide used vehicles offers
    if (val == 0 || vehicleType == 'U'  || cpoTier == 'BT') {
        //todo add on cpotier bt
        $('.offer').addClass('hidden');
    } else {
        $('.offer').removeClass('hidden');
    }
}
//click vehicle has offer link 
function applyOffer() {
    // console.log('applying offer **************');
    var termOffer = thisModelData.offerTerm;
    var a = thisModelData.offerApr;

    setCalcLayerControl(a);
    $('.spinner').show();
    //show VDP title offer
    toggleOfferTitleCalcLayer(1);

    $('.term-btn').each(function() {
        if ($(this).text() == termOffer && !$(this).hasClass('term-btn-active')) {
            $(this).trigger("click");
        }
    });

    $("#txt-apr").removeAttr("data-custom-apr");
    //run calc api again, ajaxstop function loads calc header offer title if any
    calculateMonthly(a);
    $('.spinner').hide();
}

function setOfferVDPOverlay() {
    if (thisModelData.hasOffer != '1') {
        return;
    }
    // console.log("setOfferVDPOverlay inside:  *******************");
    var desc = thisModelData.offerDescription;
    var disclaimer = thisModelData.offerDisclaimer;
    var data = '';
    var head = '<span class="cp-4">' + thisModelData.SampleAPR + '%</span> APR for ' + thisModelData.offerTerm + ' months <br><br>';
    var data1 = '<div class="row offer-text"><div class="col-xs-12"><p class="copy-text"><span class="cp-8">{head}</span><span class="cp-12">For well-qualified buyers.{text}<br>'
    var data2 = '</span></p><p class="copy-text"><span class="cp-12">{text2}</span></p></div></div></div>'
    //<div class="offers-details-wrapper">
    //    <div class="row offer-text">
    //    <div class="col-xs-12">
    //    <p class="copy-text">
    //    <span class="cp-12">0% APR for 24-36 month termsmonths available to customers who qualify for the AFS Super Preferred credit tier. 0% APR for 36 months financing at $27.78 a month per $1,000 financed. For well qualified buyers; not all buyers may qualify. Higher rates may apply for buyers with lower credit ratings. This offer is valid for all Acura Certified TSX models (model year: 2006-2011) delivered and sold from March 1, 2011 through July 21, 2011.
    //</span>
    //    </p>
    //    <p class="copy-text">
    //    <span class="cp-12">Offer valid through 07/21/2011, on Acura Certified Pre-Owned vehicles. Only on approved credit by Acura Financial Services through participating dealers. Acura Financial Services` standard credit criteria apply. See your dealer for details. Dealers set actual prices. Limited time only.</span>
    //    </p>
    //    </div>
    //    </div>
    //    </div>
    $.ajax({
        url: dataURL + '/api/offers/getfinanceoffers',
        type: 'get',
        data: {},
        dataType: "json",
        complete: function (data, status) {
            if (status == 200) {

            }
        },
        success: function(result) {
            // console.log("setOfferVDPOverlay inside disclaimer && desc  *******************", result);
            // console.log("disclaimer :: ", result["Output"]["Results"]["Specials"]["Special"][0]["TermAndConditions"]);
            // console.log("desc :: ", result["Output"]["Results"]["Specials"]["Special"][0]["SpecialDescription"]);
            var arr_length = result["Output"]["Results"]["Specials"]["Special"].length;
            // console.log("arr_length: ", arr_length)
            for (var i = 0; i < arr_length; i++) {
                var models_length = result["Output"]["Results"]["Specials"]["Special"][i]["Models"]["Model"].length;
                // console.log("models_length :: ", models_length)
                    for(var j = 0; j < models_length; j++){
                        if (result["Output"]["Results"]["Specials"]["Special"][i]["Models"]["Model"][j]["ModelMarketingName"].indexOf(thisModelData.ModelGroupName) > -1) {

                            disclaimer = result["Output"]["Results"]["Specials"]["Special"][i]["Models"]["Model"][j]["TermAndConditions"];
                            desc = result["Output"]["Results"]["Specials"]["Special"][i]["Models"]["Model"][j]["SpecialDescription"];
                        }
                    }


            }
            if (disclaimer != null && desc != null) {
                // console.log("1529 : dis: ", disclaimer);
                // console.log("1530 : des: ", desc)

                data = data1.replace('{head}', head);
                // console.log('disclaimer', disclaimer);
                if (disclaimer == "<br><br>") {
                    data = data.replace('{text}', '');
                } else {
                    data = data.replace('{text}', '<br><br>' + disclaimer);
                }
                data = data + data2.replace('{text2}', desc);
            }
            // console.log("getfinanceoffers success:  *******************", data);
            $('.offers-details-wrapper').html(data);
        },
        error: function (jqXHR, textStatus, errorThrown) {

        }
    });
}
//#endregion
//#region Calculator functions
function loadTermMonths() {
    var buttons = ['24', '36', '48', '60', '66', '72'];
    var default_button = '66';
    var data = '';
    for (var i = 0, len = buttons.length; i < len; i++) {
        if (default_button != buttons[i]) {
            data = data + '<button class="term-btn">' + buttons[i] + '</button>';
        } else {
            data = data + '<button class="term-btn term-btn-active">' + buttons[i] + '</button>';
        }
    }
    // console.log('loadTermMonths:', data);
    $('.terms').html(data);
}

function openPopUp(stringUrl, stringName, width, height) {
    //Tracking kbb
    _satellite.track('vehdetails_calculate_kbb');
    var top = (screen.height / 2) - (height / 2);
    var left = (screen.width / 2) - (width / 2);
    window.open(stringUrl, stringName, "scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left);
}

function updateTradeinValue(value) {
    if (value != 0) {
        var tval = formatTradein(value);
        $('#txt-tradein').val(tval);
        calculateMonthly(1);
    }
}

function clearZero(obj) {
    try {
        var txtbox = $(obj);
        var value = txtbox.val();
        if (parseInt(value) < 1) {
            txtbox.val('');
        }


    }
    catch (error) {
        // console.log('clearZero error:', error);
    }
}

function setCalcLayerControl(_apr) {
    if (thisModelData.hasOffer != '1') {
        toggleOfferTitleCalcLayer(0);
        return;
    }
    var apr = _apr;
    if (thisModelData.maxTerm == '1') {
        var apiAPR = $('#txt-apr').attr('data-api-apr');
        $('#txt-apr').val(apiAPR);
    } else {
        $('#txt-apr').val(apr);
    }
    //append % if not yet showing
    if ($('#txt-apr').val().indexOf('%') < 0) {
        $('#txt-apr').val($('#txt-apr').val() + '%');
    }
}

function calculateMonthly(a, termClick) {
    // console.log('calculateMonthly inside');
    var term = '';
    var dynamicAPR = $('#txt-apr').attr('data-api-apr') || thisDefaultAPR;

    $('.term-btn').each(function(index, obj) {
        if ($(this).hasClass('term-btn-active')) {
            term = $(this).text();
        }
    });
    var tradeinValue = ($('#txt-tradein').val() < 1) ? 0 : $('#txt-tradein').val();
    var downpayment = ($('#txt-downpayment').val() < 1) ? 0 : $('#txt-downpayment').val();
    thisDownpayment = downpayment;
    var modelId = thisModelData.ModelId;
    var apr = ($('#txt-apr').val() < 1) ? dynamicAPR : $('#txt-apr').val().replace(/\%/g, '');
    var msrp = thisvin.DSRP;
    thisMSRP = msrp;
    var monthly = 0;
    var g_apr = '';
    var g_shortDescription = 'short description here';
    var g_shortDisclaimer = 'short disclaimer here';
    var g_term = '';
    //change apr and term to empty, Calculator Controller->GetCalculatorConstants() will load defaults JIRA: ACPV-110
    //apr = '';
    if (a == null) {
        term = '';
        apr = '';
    }
    //rpaik begin

    if(a && typeof a === 'object') {
        apr = a.apr;
        term = a.term;
    }
    
    var hasOffers = thisModelData.Specials;
    if (hasOffers && isCalcFirstLoad && !isInitialPageLoad) {
        ////console.log("isCalcFirstLoad[if hasOffers&&isCalcFirstLoad]: " + isCalcFirstLoad)
        isCalcFirstLoad = false;
        var hasLowApr = 100, hasLowTerm = 100;
        var _hasApr, _hasLowTerm;
        var hasOffArr = hasOffers;
        hasOffArr.PaymentTerms.FinanceTerms.FinanceTerm.forEach(function(item) {
            _hasApr = parseFloat(item["APR"]);
            if (hasLowApr > _hasApr) {
                hasLowApr = _hasApr;
            }
            _hasLowTerm = parseInt(item["TermMax"]);
            if (_hasLowTerm < hasLowTerm) {
                hasLowTerm = _hasLowTerm;
            }
        });
        term = hasLowTerm;
        apr = hasLowApr;
    }
    
    //rpaik end

    $.ajax({
        url: dataURL + '/api/calculators/ComputeFinancePayment',
        type: 'get',
        data: {
            apr: apr,
            term: term,
            msrp: msrp,
            downpayment: downpayment,
            TradeInValue: tradeinValue,
            modelid: modelId
        },
        dataType: "json",
        complete: function (data, status) {
            if (status == 200) {

            }
        },
        success: function(result) {
            // console.log('Monthly API success :', result);
            //monthly = result["Output"]["Results"]["MonthlyPayment"];
            monthly = result["MonthlyPayment"];
            thisMonthly = monthly;

            //set default apr
            // if(!apr) {
            //     $('#txt-apr').val(`${result.APR}%`); 
            // }

            // Select term month on calc popup
            $('.term-btn').each(function() {
                $(this).removeClass('term-btn-active');
                if ($(this).text() == result.Term) {
                    $(this).addClass('term-btn-active');
                }
            });
            if (result["Specials"] != null && thisModelData.VehicleType != 'U' && thisModelData.CPOTier !== 'BT') {
                if (result["Specials"]["FinanceSpecial"] != null) {
                    var lowApr = thisModelData.SampleAPR, lowTerm = thisModelData.SampleTerm;
                    var arr = result["Specials"]["FinanceSpecial"];
                    //var offerData = JSON.parse(hasOffers);
                    if(!hasOffers) {
                        return;
                    }
                    var financeTermArray = hasOffers.PaymentTerms.FinanceTerms.FinanceTerm;
                    var customAPR = $('#txt-apr').attr("data-custom-apr");

                    // Ensure that the offer APR is only showing with the offer term lengths.
                    // Then user must be able to enter in their own APR and click each term length to see the payment. 
                    if (termClick && !customAPR) {
                        var aprIndex = financeTermArray.findIndex(item => item["TermMin"] === arr["TermMin"]);
                    
                        if (aprIndex !== -1) {
                            $('#txt-apr').val(financeTermArray[aprIndex]["APR"] + "%");
                            lowApr = financeTermArray[aprIndex]["APR"];
                            lowTerm = $(".term-btn-active").text();
                        } else {
                            $('#txt-apr').val(dynamicAPR + "%");
                        }
                    } 

                    setOfferFieldValues(lowApr,
                        lowTerm,
                        thisModelData.offerDescription,
                        thisModelData.offerDisclaimer,
                        lowApr,
                        lowTerm);
                        thisModelData.maxTerm = ''; //user clicked on a term not excluded in multiple offers for this vehicle
                    setOfferTitleCalcLayer();

                    $('.term-btn').each(function() {
                        var activeTermsBoxes = $(this).parent().find('.term-btn-active');

                        if ($(this).text() == lowTerm && a == null && activeTermsBoxes.length == 0) {
                            $(this).addClass('term-btn-active');
                        }
                    });

                } else {
                    //result["Output"]["Results"]
                    //if first page load, get offers data from hidden value. Find the lowest term and populate the associated APR
                    if (isInitialPageLoad) {
                        isInitialPageLoad = false;
                        var lowApr = 100,
                            lowTerm = 100;
                        var _apr, _lowTerm;
                        var hasOffers_data = thisModelData.hasOffer;
                        var hasOffersArr = JSON.parse(hasOffers_data);
                        _apr =
                          hasOffersArr.Special[0].PaymentTerms.FinanceTerms
                            .SampleFinancePayment.SampleAPR;

                        if (lowApr > _apr) {
                          lowApr = _apr;
                        }

                        _lowTerm =
                          hasOffersArr.Special[0].PaymentTerms.FinanceTerms
                            .SampleFinancePayment.SampleTerm;
                        if (_lowTerm < lowTerm) {
                          lowTerm = _lowTerm;
                        }

                        // hasOffersArr.Special[0].PaymentTerms.FinanceTerms.FinanceTerm.forEach(function(item) {
                        //     _apr = parseFloat(item["APR"]);
                        //     if (lowApr > _apr) {
                        //         lowApr = _apr;
                        //     }
                        //     _lowTerm = parseInt(item["TermMax"]);
                        //     console.log('1763 _lowTerm: ',_lowTerm)
                        //     console.log('1764 lowTerm: ',lowTerm)

                        //     if (_lowTerm < lowTerm) {
                        //         lowTerm = _lowTerm;
                        //     }
                        // });
                        g_apr = lowApr;
                        g_shortDescription = hasOffersArr.Special[0].SpecialShort;
                        g_shortDisclaimer = result["Specials"]["FinanceSpecial"]["ShortDisclaimer"] === '' ? g_shortDisclaimer : result["Specials"]["FinanceSpecial"]["ShortDisclaimer"];
                        g_term = lowTerm;
                    }  else {
                        g_apr = result["Specials"]["FinanceSpecial"]["APR"] == "" ? g_apr : result["Specials"]["FinanceSpecial"]["APR"];
                        g_shortDescription = result["Specials"]["FinanceSpecial"]["ShortDescription"] === '' ? g_shortDescription : result["Specials"]["FinanceSpecial"]["ShortDescription"];
                        g_shortDisclaimer = result["Specials"]["FinanceSpecial"]["ShortDisclaimer"] === '' ? g_shortDisclaimer : result["Specials"]["FinanceSpecial"]["ShortDisclaimer"];
                        g_term = result["Specials"]["FinanceSpecial"]["Term"] === '' ? g_term : result["Specials"]["FinanceSpecial"]["Term"];
                    }
                    // //console.log("calc monthly success: vehicle with Offer *****");
                    if (thisModelData.offerAprVdp != '') {
                        setOfferFieldValues(g_apr, g_term, g_shortDescription, g_shortDisclaimer, thisModelData.offerAprVdp, thisModelData.offerTermVdp);
                    } else {
                        setOfferFieldValues(g_apr, g_term, g_shortDescription, g_shortDisclaimer, g_apr, g_term);
                    }
                    $('.term-btn').each(function(index, obj) {
                        $(this).removeClass('term-btn term-btn-active').addClass('term-btn');
                        if ($(this).text() == g_term) {
                            // console.log('calculateMonthly Return - 1605', $(this));
                            $(this).addClass('term-btn-active');
                        }
                    });
                }
            } else {
                var arr = result;
                //no specials, change values of apr and term from CalcAPI 
                $('#txt-apr').val(arr["APR"] + '%');
                $('#txt-apr').attr('data-api-apr', arr["APR"] + '%');

                // console.log('calculateMonthly Return - 1615');
                $('.term-btn').each(function(index, obj) {
                    // $(this).removeClass('term-btn term-btn-active').addClass('term-btn');
                    if ($(this).text() == arr["Term"] && term == '') {
                        // console.log('calculateMonthly Return - 1603', $(this));
                        $(this).addClass('term-btn-active');
                    }
                });
            }
            // console.log(monthly);
            // console.log("success monthly total");
            clearErrorDownpayment($('#txt-downpayment'))
            clearErrorTradein($('#txt-tradein'))
            // Add DTM after everything is loaded: InventoryDetails.cshtml
            addDtmDataLayertoVDP();
            // Tracking
            _satellite.track('vehdetails_page_ready');
            $('[name=amountmonthly]').html('$' + monthly); //calculate overlay layer header
            //console.log("monthly: " + monthly);

            $('#monthlyPaymentAlert').html(`<div class="paymentNotice cp-13">ESTIMATED MONTHLY PAYMENT<br /><span class="cp-7">$${monthly}<sup><a style="font-size: 20px;" class="disclaimer-callout" data-disclaimers-content="${vehicleCardDisclaimer}">*</a></sup></span><br /><span class="down-copy">${apr ? apr : result.APR}% APR up to ${term ? term : result.Term } months, ${Math.round((downpayment / msrp) * 100)}% down </span></div>`);
            vdpWrapper.attr('data-tap-offer-monthly', `$${monthly}`);
            vdpWrapper.attr('data-tap-offer-description', `${apr ? apr : result.APR}% APR up to ${term ? term : result.Term } months, ${Math.round((downpayment / msrp) * 100)}% down`);
            //if ($('#mpestAmout').html() == '') {
            //    $('#monthlyPaymentAlert').html('<div class="paymentNotice cp-13">ESTIMATED MONTHLY PAYMENT<br /><span class="cp-7">$' + monthly + '</span> <div class="mpestIcon" data-toggle="tooltip" data-placement="bottom" title="Excludes taxes, titles and fees. For well-qualified buyers.">i</div><br />10% down / 60 months</div>');
                //$('#mpestAmout').html('$' + monthly);
            //}
        
        },
        error: function(jqXHR, textStatus, errorThrown) {
            // console.log("did not work");
            // console.log("no monthly above");
            // console.log("jqXHR:", jqXHR);
            // console.log("textStatus:", textStatus);
            // console.log("errorThrown:", errorThrown);
            $('[name=amountmonthly]').html("0");
        }
    });
}

function validateNumber(evt) {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    var regex = /[0-9\b]|\./;
    if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
    }
}

function validateCalcNumber(txt, evt) {
    var theEvent = evt || window.event;
    // console.log('validateCalcNumber:', txt.value)
    // console.log('validateCalc Length:', txt.value.split('.').length)
    if (evt.keyCode === 46 && txt.value.split('.').length == 2) {
        // console.log('validateCalcNumber inside:')
        theEvent.preventDefault();
        return false;
    }
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    var regex = /[0-9\b]|\./;
    if (!regex.test(key) || txt.value.split('.').length > 2) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
    }
}

function checkDownpayment(amt, totalprice, dpTxt, divId) {
    try {
        amt = amt.replace(/\,/g,'');
        var x = amt;
        totalprice = parseInt(totalprice) - 5000; //car must be finance-able
        var tradeinValue = $('#txt-tradein').val().replace(/\,/g,'');
        var retVal = false;
        var txtbox = $(dpTxt);
        if (x.length < 1 || parseInt(amt) === 0) {
            $(txtbox).val('0');
            $('[name=errdownpayment]').removeClass('errMessage').addClass('errMessage hidden');
            $(divId).attr('style', 'border:0px;');
            return false;
        }
        amt = parseInt(amt) + parseInt(tradeinValue);
        // console.log('checkDownpayment amt:', amt);
        // console.log('checkDownpayment totalprice:', totalprice);
        if ((amt > totalprice)) {
            $('[name=errdownpayment]').removeClass('errMessage hidden').addClass('errMessage');
            $(divId).attr('style', 'border:1px solid red');
            $('[name=errtradein]').removeClass('errMessage hidden').addClass('errMessage');
            $('#div-tradein').attr('style', 'border:1px solid red');
            return false;
        } else {
            $('[name=errdownpayment]').removeClass('errMessage').addClass('errMessage hidden');
            $(divId).attr('style', 'border:0px;');
            $('#div-tradein').attr('style', 'border:0px;');
        }
        return true;
    }
    catch (error) {
        // console.log('checkDownpayment error:', error);
        return false;
    }
}

function checkTradeinValue(amt, txtId, totalprice, divId) {
    amt = amt.replace(/\,/g,'');
    var txtbox = $(txtId);
    totalprice = totalprice - 5000; //car must be finance-able
    if (amt.length < 1 || parseInt(amt) === 0) {
        $(txtbox).val('0');
        $(divId).attr('style', 'border:0px;');
        //  console.log("checkTradeinValue return false 1:");
        // return false;
    }
    var trade_amt = parseInt(amt);
    var downPmt = $('#txt-downpayment').val();
    var tot_cash_amt = parseInt(downPmt) + trade_amt;
    // console.log('checkTradeinValue:', txtbox.length);
    //comment below for now, until we get a message for issue on down+tradein > msrp, 
    if ((tot_cash_amt > totalprice)) {
        // console.log(amt);
        $('[name=errtradein]').removeClass('errMessage hidden').addClass('errMessage');
        $('[name=errdownpayment]').removeClass('errMessage hidden').addClass('errMessage');
        $(divId).attr('style', 'border:1px solid red');
        $('#div-downpayment').attr('style', 'border:1px solid red');
        // console.log("checkTradeinValue return false 2:");
        return false;
    } else {
        $('[name=errdownpayment]').removeClass('errMessage').addClass('errMessage hidden');
        $('[name=errtradein]').removeClass('errMessage').addClass('errMessage hidden');
        $(divId).attr('style', 'border:0px;');
        $('#div-downpayment').attr('style', 'border:0px;');
    }
    return true;
}

function checkAPR(amt, totalapr) {
    var x = amt;
    if (isNaN(x.replace(/\%/g, ''))) {
        // console.log('checkTradeinValue isNaN:');
        $('#txt-apr').removeClass('text-input-apr').addClass('text-input-redbox');
        return false;
    }
    amt = parseFloat(amt);
    if (x.length > 0) {
        if (amt > 0 && amt < 1 && x.indexOf('0') == -1 && x.indexOf('%') == -1) {
            // console.log('checkAPR 1 :::', x.indexOf('0'));
            $('#txt-apr').val('0' + $('#txt-apr').val() + '%');
        } else if (amt > 0 && amt < 1 && x.indexOf('0') == -1 && x.indexOf('%') > -1) {
            // console.log('checkAPR 2:');
            $('#txt-apr').val('0' + $('#txt-apr').val());
        } else if (x.indexOf('%') == -1 && amt > 1) {
            // console.log('checkAPR 3:');
            $('#txt-apr').val($('#txt-apr').val() + '%');
        }
    }
    if (amt < 0) {
        $('[name=errapr]').removeClass('errMessage hidden').addClass('errMessage');
        $('#txt-apr').removeClass('text-input-apr').addClass('text-input-redbox');
        return false;
    } else {
        // console.log('amt > 0', amt)
    }
    if (amt > totalapr) {
        $('[name=errapr]').removeClass('errMessage hidden').addClass('errMessage');
        $('#txt-apr').removeClass('text-input-apr').addClass('text-input-redbox');
        return false;
    }
    $('#txt-apr').removeClass('text-input-redbox').addClass('text-input-apr');
    return true;
}

function clearErrorAPR(obj) {
    $('[name=errapr]').removeClass('errMessage').addClass('errMessage hidden');
    $('#txt-apr').removeClass('text-input-redbox').addClass('text-input-apr');
    var s = $(obj).val();
    // console.log(s);
    if (s.length > 0) {
        $('#txt-apr').val(s);
    }
}

function clearErrorDownpayment(obj) {
    $('[name=errdownpayment]').removeClass('errMessage').addClass('errMessage hidden');
    $('#txt-downpayment').removeClass('text-input-redbox').addClass('text-input-number');
    var s = $(obj).val();
    // console.log(s);
}

function clearErrorTradein(obj) {
    $('[name=errtradein]').removeClass('errMessage').addClass('errMessage hidden');
    $('#txt-tradein').removeClass('text-input-redbox').addClass('text-input-number');
    var s = $(obj).val();
    // console.log(s);
}
//#endregion
//#region JS functions for Contact Dealer Overlay
function phoneno(txt) {
    $(txt).keypress(function(e) {
        var a = [];
        var k = e.which;
        var i = 0;
        for (i = 48; i < 58; i++) {
            a.push(i);
        } if (!(a.indexOf(k) >= 0)) e.preventDefault();
    });
}

function showDivError(elem) {
    $(elem).removeClass('errMessage hidden').addClass('errMessage');
}

function highlightTextbox(txtctl) {
    $(txtctl).removeClass('input-textbox').addClass('input-textbox invalidtext');
    $('#submitdisclaimer').focus();
   // $('#privacypolicy').css('color', 'red');
}

function hideDivError(elem) {
    $(elem).removeClass('errMessage').addClass('errMessage hidden');
}

function noHighlightTextbox(txtctl) {
    $(txtctl).removeClass('input-textbox invalidtext').addClass('input-textbox');
}

function isValidEmailAddress(emailAddress) {
    var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    return pattern.test(emailAddress);
};

function isNumber(e) {
    return !isNaN(parseFloat(e)) && isFinite(e);
}

function checkForm() {
    var form_data = $('#contactform').serializeArray();
    var error_free = true;
    //zip validation, only allow min 5 digits
    if ($('#zip').val().length != 5) {
        $('[name=errzip]').removeClass('errMessage hidden').addClass('errMessage');
        showDivError('zip');
        highlightTextbox('zip');
        $('#zip').addClass('input-textbox invalidtext');
        error_free = false;
    } 

    for (var input in form_data) {
        var ctlerr = '[name=err' + form_data[input]['name'] + ']';
        var fld = form_data[input]['name'];
        var txt = '#' + form_data[input]['name'];
        var element = $(ctlerr);
        var arr_ctrl1 = [];
        arr_ctrl1.push('firstname');
        arr_ctrl1.push('lastname');
        //arr_ctrl1.push('zip');
        var arr_ctrl2 = [];
        arr_ctrl2.push('email');
        arr_ctrl2.push('phone');
        arr_ctrl2.push('text');
        //console.log("arr_ctrl2: "+ arr_ctrl2)
        //check firstname, lastname and zip
        if (jQuery.inArray(fld, arr_ctrl1) != -1) {
            if ($(txt).val() != null && $(txt).val() != '') {
                hideDivError(element);
                noHighlightTextbox(txt);
            } else {
                showDivError(element);
                highlightTextbox(txt);
                error_free = false;
            }
        }

        var ctlerr = '[name=errpreferred]';
        var element = $(ctlerr);
        var email = $('input[name="email"]').val();
        var call = $('input[name="phone"]').val();
        var txtmessage = $('input[name="text"]').val();
        
        //check if any of preferred contacts is selected
        
        if (jQuery.inArray(fld, arr_ctrl2) != -1) {
            //validate email   

            if ($('#em').hasClass("active") && jQuery.trim(email).length <= 1) {
                showDivError(element);
                $('#errpreferred span').text('Enter your email');
                error_free = false;
                return false;
            }
            if ($('#em').hasClass("active") && jQuery.trim(email).length > 1) {
                if (!isValidEmailAddress(email)) {
                    showDivError(element);
                    $('#errpreferred span').text('Enter a valid email');
                    error_free = false;
                    return false;
                }
            }
            
            //validate call number
            
            if ($('#ph').hasClass('active')){
                if(jQuery.trim(call).length < 1){
                    showDivError(element);
                    $('#errpreferred span').text('Enter your phone number');
                    error_free = false;
                    return false;
                }
                
                if (jQuery.trim(call).length < 10 || jQuery.trim(call).length > 10) {
                    error_free = false;
                    showDivError(element);
                    $('#errpreferred span').text('Enter a valid phone number');
                    return false;
                }
                if (jQuery.trim(call).length == 10) {
                    if (!isNumber(call)) {
                        showDivError(element);
                        $('#errpreferred span').text('Enter a valid phone number');
                        return false;
                    }
                }
            } 
            //validate text number
            if ($('#tx').hasClass('active')){
                if(jQuery.trim(txtmessage).length < 1){
                    showDivError(element);
                    $('#errpreferred span').text('Enter your phone number');
                    error_free = false;
                    return false;
                }
                
                if (jQuery.trim(txtmessage).length < 10 || jQuery.trim(txtmessage).length > 10) {
                    error_free = false;
                    showDivError(element);
                    $('#errpreferred span').text('Enter a valid phone number');
                    return false;
                }
                if (jQuery.trim(txtmessage).length == 10) {
                    if (!isNumber(txtmessage)) {
                        showDivError(element);
                        $('#errpreferred span').text('Enter a valid phone number');
                        return false;
                    }
                }
            } 
            
            // if ($('#ph').hasClass('active') && jQuery.trim(call).length < 1) {
            //     showDivError(element);
            //     $('#errpreferred span').text('Enter your phone number');
            //     error_free = false;
            //     return false;
            // }
            // if ($('#ph').hasClass('active') && jQuery.trim(call).length < 10) {
            //     error_free = false;
            //     showDivError(element);
            //     $('#errpreferred span').text('Enter a valid phone number');
            //     return false;
            // }
            // if ($('#ph').hasClass('active') && jQuery.trim(call).length == 10) {
            //     if (!isNumber(call)) {
            //         showDivError(element);
            //         $('#errpreferred span').text('Enter a valid phone number');
            //         return false;
            //     }
            // }

            //validate text number
            // if ($('#tx').hasClass('active') && jQuery.trim(txtmessage).length < 1) {
            //     showDivError(element);
            //     $('#errpreferred span').text('Enter your phone number');
            //     error_free = false;
            //     return false;
            // }
            // if ($('#tx').hasClass('active') && jQuery.trim(txtmessage).length < 10) {
            //     error_free = false;
            //     showDivError(element);
            //     $('#errpreferred span').text('Enter a valid phone number');
            //     return false;
            // }
            // if ($('#tx').hasClass('active') && jQuery.trim(txtmessage).length == 10 && !jQuery.isNumeric(txtmessage)) {
            //     error_free = false;
            //     showDivError(element);
            //     $('#errpreferred span').text('Enter a valid phone number');
            //     return false;
            //}
            //if (!methodOfContactSelected()) {
            //    error_free = false;
            //    showDivError(element);
            //    $('#errpreferred span').text('Select at least one method of contact');
            //    return false;
            //}
        }
    }

    if ($('#submitdisclaimer').hasClass('unchecked')) {
        $('#submitdisclaimer').focus();
        $('#submitdisclaimer').css('border-color', 'red');
        //console.log('privacypolicy false ')
        return false;
    } else {
        $('#submitdisclaimer').css('border-color', '#000');
        // console.log('privacypolicy true ')
    }

    return error_free;
}

function methodOfContactSelected() {
    return $('#textmessagecontact').hasClass("checked") || $('#callcontact').hasClass("checked") || $('#emailcontact').hasClass("checked");
}

function validateForm() {
    var isvalid = checkForm();
    if (!isvalid) {
        $("#retainFlag").val("1");
        $("#contactform").data('submitted', false);
    } else {
        $("#retainFlag").val("");
    }
}
//#endregion
//#region JS functions for Similar vehicles
function addCommas(nStr) {
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}

function getDealerObject(obj, key, val) {
    var objects = [];
    for (var i in obj) {
        if (!obj.hasOwnProperty(i)) continue;
        if (typeof obj[i] == 'object') {
            objects = objects.concat(getDealerObject(obj[i], key, val));
        } else if (i == key && obj[key] == val) {
            objects.push(obj);
        }
    }
    return objects;
}

function formatCurrency(n) {
    var money = n.toString().replace('.00', '')
    return '$' + addCommas(money);
}

function formatTradein(n) {
    var money = n.toString().replace('.00', '')
    return money;
}

function isEmpty(val) {
    return (val === undefined || val == null) ? true : false;
}

function getVehicleDealerObject() {
    //var url = 'http://acuracertified/api/inventory/similarvehicles/?zip=90404&modelYearStart=2014&modelYearEnd=2015&priceLimit=50000&mileageLimit=70000';
    //console.log('getVehicleDealerObject - loading...'); 
    var _zip = thisModelData.DealerZip;
    var _yrstart = thisModelData.ModelYear;
    var _yrend = thisModelData.ModelYear;
    var _miles = parseInt(thisModelData.Mileage) + 10000;
    var _price = parseInt(thisModelData.DSRP) + 10000;
    var _modelgroupName = thisModelData.ModelGroupName;
    //console.log('getVehicleDealer ajax calling...');
    //console.log('zip:', _zip.substring(0, 5));
    //console.log('modelYearStart:', _yrstart);
    //console.log('modelYearEnd:', _yrend);
    //console.log('priceLimit:', _price);
    //console.log('mileageLimit: ', _miles);
    $.ajax({
        url: dataURL + '/api/inventory/similarvehicles',
        type: 'get',
        data: {
            zip: _zip.substring(0, 5),
            modelYearStart: _yrstart,
            modelYearEnd: _yrend,
            priceLimit: _price,
            mileageLimit: _miles,
            modelGroupName: _modelgroupName
        },
        dataType: "json",
        complete: function(data, status) {
            if (status == 200) {
                console.log('getVehicleDealerObject complete. no return result');
            }
        },
        success: function(result) {
            //console.log('ok ajx result - getVehicleDealerObject');   //Output - Results - MonthlyPayment 
            //console.log(result);
            getRelatedVehiclesDealers(result);
            return result;
        },
        error: function(jqXHR, textStatus, errorThrown) {
            // console.log("failed ajax call - getSimilarVehicles");
            return null;
        }
    });
}

//here we open the tooltip of fair element
// function openFairToolTip(vehicle) {
//     let fairElement = $('#fair-tooltip' + vehicle);

//     if (fairElement.hasClass('show-tooltip')) {
//         fairElement.removeClass('show-tooltip');
//     }
//     else {
//         fairElement.addClass('show-tooltip');
//     }
// }

// here we open the used tooltip
function openUsedToolTip(e) {
    let usedElement = $('#tooltip-info-used');
    let idClicked = $(e.target).attr('id');

    if(idClicked === 'tooltip-info') {
        if (usedElement.hasClass('show-tooltip')) {
            usedElement.removeClass('show-tooltip');
        } 
        else {
            usedElement.addClass('show-tooltip');
        }
    }
}

function openBuyOnlineToolTip(e) {
    let usedElement = $('#tooltip-info-buy-online');
    let idClicked = $(e.target).attr('id');

    if(idClicked === 'tooltip-buy-online') {
        if (usedElement.hasClass('show-tooltip')) {
            usedElement.removeClass('show-tooltip');
        } 
        else {
            usedElement.addClass('show-tooltip');
        }
    }
}

function getRelatedVehiclesDealers(data) {
    let Models = data["Output"]["Results"]["Models"];
    let similarVehicles = [];
    let similarVins = [];

    //console.log('getSimilarVehicles ', similarVehicles);
    if (!isEmpty(data)) {
        try {
            // console.log('getSimilarVehicles - HTML DOM working...');
            // console.log('getSimilarVehicles ', data);
            var totalCountSimilarVeh = parseInt(data["Output"]["Results"]["TotalRecordCount"]);
            // var subscriptionAmount = $('[name=_SubscriptionAmount]').val();
            // console.log('getSimilarVehicles count:', totalCountSimilarVeh);
            if (totalCountSimilarVeh > 1) {
                //19UNC1B03HY000072
                var _similarveh_url = "https://www.acura.com/assets";
                let vehicleType = thisModelData.VehicleType;
                let cpoTier = thisModelData.CPOTier;
                ///// SIMILAR VEHICLE 1
                //LOOP THROUGH DATA MAKE SURE SIMILAR VEHICLE 1 DOESNT MATCH CURRENT VEHICLE IN VDP
                var veh_count = 0;
                let svehicle1 = $('#similar-vehicles-wrapper-1');
                let svehicle2 = $('#similar-vehicles-wrapper-2');
                let svehicle3 = $('#similar-vehicles-wrapper-3');
                for (let v = 0;v < Models['Model'].length; v++) {
                    for (let vin =0;vin < Models['Model'][v]['ModelVINsOnSite']['VIN'].length;vin++) {
                        let simVin = Models['Model'][v]['ModelVINsOnSite']['VIN'][vin]['VIN'];
                        let simVehicleType = Models['Model'][v]['ModelVINsOnSite']['VIN'][vin]['VehicleType'];
                        let simCPOTier = Models['Model'][v]['ModelVINsOnSite']['VIN'][vin]['CPOTier'];
                        //console.log(v,thisModelData.VIN,simVin, simVehicleType ,simCPOTier,  (simVin != thisModelData.VIN && simVehicleType == vehicleType && simCPOTier == cpoTier))
                        if (simVin != thisModelData.VIN && simVehicleType == vehicleType && simCPOTier == cpoTier) {
                            //check if vin is unique and different than vdp model
                            if (similarVins.indexOf(Models['Model'][v]['ModelVINsOnSite']['VIN'][vin]['VIN'] < 0)) {
                                //set modelimage
                                var modelImage = thisModelData.VehicleImage;
                                if (Models['Model'][v]['ModelVINsOnSite']['VIN'][vin]["Photos"] != null) {
                                    //get dealer photos
                                    if (Models['Model'][v]['ModelVINsOnSite']['VIN'][vin]["Photos"]["Photos"]["Photo"][0]["#text"] != null) {
                                        modelImage = Models['Model'][v]['ModelVINsOnSite']['VIN'][vin]["Photos"]["Photos"]["Photo"][0]["#text"]
                                    }
                                    //get stock photos IF dealer photos == NULL
                                } else if (Models['Model'][v]['ModelVINsOnSite']['VIN'][vin]["ModelStockPhotos"] != null &&
                                Models['Model'][v]['ModelVINsOnSite']['VIN'][vin]["ModelStockPhotos"]["Photos"][0]["Photo"] != null &&
                                Models['Model'][v]['ModelVINsOnSite']['VIN'][vin]["ModelStockPhotos"]["Photos"][0]["Photo"][0]["#text"] != null) {
        
                                        modelImage = _similarveh_url + Models['Model'][v]['ModelVINsOnSite']['VIN'][vin]["ModelStockPhotos"]["Photos"][0]["Photo"][0]["#text"]
                                    
                                }
                                else {
                                    //no photos avail. set to no image 
                                    modelImage = thisModelData.PhotosNoImage;
                                }
                                //model dealer
                                let dealerid = Models['Model'][v]["@DealerId"];
                                let dealer = getDealerObject(data, 'DealerID', dealerid);
                                let DealerName = dealer[0]['DealerName'];
                                let dealerURL = dealer[0]['DealerURL'];
                                let dealerDistance = dealer[0]['DealerDistance'];

                                let buyOnline = Models['Model'][v]['ModelVINsOnSite']['VIN'][vin]["BuyOnline"]
                                let buyOnlineData = (buyOnline == null || buyOnline == 'undefined') ? null : buyOnline;
                                let simHasBuyOnline;
                                if (buyOnlineData != null) { 
                                    simHasBuyOnline = buyOnlineData['@OnlineRetailingPreferredVIN'];
                                    if (buyOnlineData['@OnlineRetailingPreferredVIN']) {
                                    svehicle1.attr('data-tap-dealer-options','buyonline');                             
                                    }
                                } else {
                                    simHasBuyOnline = 'false';
                                }

                                let similarModel = {
                                    vin: Models['Model'][v]['ModelVINsOnSite']['VIN'][vin]['VIN'],
                                    buyonline: buyOnlineData,
                                    vehicleType : Models['Model'][v]['ModelVINsOnSite']['VIN'][vin]["VehicleType"],
                                    cpoTier: Models['Model'][v]['ModelVINsOnSite']['VIN'][vin]['CPOTier'],
                                    dealerID: dealerid,
                                    dealerName: DealerName,
                                    dealerDistance: dealerDistance,
                                    dealerURL: dealerURL,
                                    simHasBuyOnline: simHasBuyOnline,
                                    modelYear: Models['Model'][v]['ModelYear'],
                                    modelGroup : Models['Model'][v]['ModelGroupName'],
                                    modelPackage : Models['Model'][v]['ModelMarketingName'],
                                    modelTrim: Models['Model'][v]['ModelTrim'],                                    
                                    modelPrice : Models['Model'][v]['ModelVINsOnSite']['VIN'][vin]["DSRP"],
                                    modelMiles : Models['Model'][v]['ModelVINsOnSite']['VIN'][vin]["Mileage"],
                                    modelExteriorColor:Models['Model'][v]['ModelVINsOnSite']['VIN'][vin]['ModelExteriorColorName'],
                                    modelInteriorColor:Models['Model'][v]['ModelVINsOnSite']['VIN'][vin]['ModelInteriorColorName'],
                                    modeldealerid: Models['Model'][v]["@DealerId"],
                                    modelImage : modelImage
                                }
                                similarVins.push(simVin);
                                similarVehicles.push(similarModel);
                            }
                        }
                        
                    }
                }
                if (similarVehicles.length > 0) {
                    let totalCount = similarVehicles.length
                    if (similarVehicles.length > 3) {
                        totalCount = 3;
                    }
                    let thisVehicle;
                    let contactBtn
                    //console.log('totalCount',totalCount)
                    for (let s = 0; s< totalCount; s++) {
                        let elementIndex = s+1;
                        switch (elementIndex) {
                            case 1:
                                thisVehicle = $('#similar-vehicles-wrapper-1');
                                contactBtn = $('#contact-dealer-button-bottom-left');
                                break;
                            case 2: 
                                thisVehicle = $('#similar-vehicles-wrapper-2');
                                contactBtn = $('#contact-dealer-button-bottom-middle');
                                break;
                            case 3:
                                thisVehicle = $('#similar-vehicles-wrapper-3');
                                contactBtn = $('#contact-dealer-button-bottom-right');
                                break;
                        }

                        //console.log('element ',thisVehicle)
                        //console.log('models',similarVehicles);
                        thisVehicle.attr('data-tap-element-id','similar-vehicle');
                        if (similarVehicles[s].simHasBuyOnline != 'false') {
                            //console.log('buying online', similarVehicles[s].simHasBuyOnline)
                            thisVehicle.attr('data-tap-dealer-options','buyonline');  
                        }
                        thisVehicle.attr('data-tap-model-name',similarVehicles[s].modelGroup);
                        thisVehicle.attr('data-tap-model-year',similarVehicles[s].modelYear);
                        thisVehicle.attr('data-tap-model-trim',similarVehicles[s].modelTrim);
                        thisVehicle.attr('data-tap-model-mspr',similarVehicles[s].modelPrice);
                        thisVehicle.attr('data-tap-model-exterior-color',similarVehicles[s].modelExteriorColor);
                        thisVehicle.attr('data-tap-model-interior-color',similarVehicles[s].modelInteriorColor);
                        let ProgramID = (similarVehicles[s].vehicleType != 'U') ? similarVehicles[s].cpoTier === 'BT' : 'presicion_used' ? 'precision_certified':'used';
                        thisVehicle.attr('data-tap-model-program-id',ProgramID);
                        thisVehicle.attr('data-tap-dealer-id', similarVehicles[s].dealerID);
                        thisVehicle.attr('data-tap-dealer-name',similarVehicles[s].dealerName);
                        thisVehicle.attr('data-tap-dealer-distance',similarVehicles[s].dealerDistance);
                        thisVehicle.removeClass('item similar-vehicle bg-light-grey hidden').addClass('item similar-vehicle bg-light-grey');
                        let type = vehicleType !== 'U' ? cpoTier === 'BT' ? 'precision-used' : 'precision' : 'used';
                        $('#vehicle-type-'+elementIndex).removeClass('vehicle-precision-type hidden').addClass(`vehicle-${type}-type`).html(`<span>${similarVehicles[s].vehicleType !== 'U' ? similarVehicles[s].cpoTier === 'BT' ? 'Precision Used' : 'Precision Certified' : 'Used Vehicle'}</span>`);

                        contactBtn.attr("href", window.acpv.createJumpLink("/shopping/inventory/vehicle?vinSlug=" + similarVehicles[s].vin))
                        //images change
                        $('#similar-vehicles-img-'+elementIndex).html("<img src='" + similarVehicles[s].modelImage + "'>")
                        //copy left change
                        $('#similar-vehicles-copyleft-'+elementIndex).html('<p class="year-model hl-8">' + similarVehicles[s].modelYear + ' ' + similarVehicles[s].modelGroup + '</p>' + (similarVehicles[s].modelPackage === null ? '<p class="package cp-6" style="visibility:hidden;">PACKAGE' : similarVehicles[s].modelPackage.replace("with", "")) + '</p> <p class="miles cp-6">' + addCommas(similarVehicles[s].modelMiles) + ' miles</p><p class="dealer cp-11"><span class="acpv-icon pin-black" style="width: 21px; height: 17px;"></span></span><a href="' + similarVehicles[s].dealerURL + '" target="_blank" style="color: black; text-decoration: underline; margin-top: 4px; width: 100%;" data-tracking="vehdetails_dealer_website">'+ similarVehicles[s].dealerName +'</a></p></div>')
                        //copy right change
                        $('#similar-vehicles-copright-'+elementIndex).html(' <p class="price hl-9">' + formatCurrency(similarVehicles[s].modelPrice) + '</p>')
                    }

                } else {
                    $('#similarvehicles').css("display", "none");
                }

                console.clear;



                // for (var vehicle in data["Output"]["Results"]["Models"]["Model"]) {
                //     var _1similarmodelvin = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["VIN"]
                //     var _1similarmodelvehicle_type = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["VehicleType"]
                //     var _1similarmodelcpotier = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["CPOTier"]
                //     console.log(thisModelData.VIN, _1similarmodelvin, _1similarmodelcpotier , cpoTier, (thisModelData.VIN != _1similarmodelvin && _1similarmodelvehicle_type == vehicleType && _1similarmodelcpotier == cpoTier ))

                    
                //     if (thisModelData.VIN != _1similarmodelvin && _1similarmodelvehicle_type == vehicleType && _1similarmodelcpotier == cpoTier ) {
                //         var _1similarmodelYear = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelYear"]
                //         var _1similarmodelgroup = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelGroupName"]
                //         var _1similarmodelpackage = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelMarketingName"]
                //         var _1similarmodelprice = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["DSRP"]
                //         var _1similarmodelmiles = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["Mileage"]
                //         var _1similarmodeldealerid = data["Output"]["Results"]["Models"]["Model"][veh_count]["@DealerId"]
                //         // var _1vehicleamount = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["Subscription"]["@Amount"]
                //         // var _1vehicleurl= data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["Subscription"]["#text"]
                //         var _1similarmodelimage = thisModelData.VehicleImage;
                //         if (data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["Photos"] != null) {
                //             //get dealer photos
                //             if (data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["Photos"]["Photos"]["Photo"][0]["#text"] != null) {
                //                 // console.log('similar 1');
                //                 _1similarmodelimage = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["Photos"]["Photos"]["Photo"][0]["#text"]
                //             }
                //             //get stock photos IF dealer photos == NULL
                //         } else if (data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["ModelStockPhotos"] != null &&
                //             data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["ModelStockPhotos"]["Photos"][0]["Photo"] != null &&
                //             data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["ModelStockPhotos"]["Photos"][0]["Photo"][0]["#text"] != null) {

                //             _1similarmodelimage = _similarveh_url + data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["ModelStockPhotos"]["Photos"][0]["Photo"][0]["#text"]
                            
                //         }
                //         else {
                //             //no photos avail. set to no image 
                //             _1similarmodelimage = thisModelData.PhotosNoImage;
                //         }

                //         //for tap
                //         //set vdp wrapper tap data
                //         svehicle1.attr('data-tap-element-id','similar-vehicle');
                //         let simvin = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]
                //         let buyOnlineData = (simvin["BuyOnline"] == null || simvin["BuyOnline"] == 'undefined') ? null : simvin["BuyOnline"];
                //         let simHasBuyOnline;
                //         if (buyOnlineData != null) { 
                //             simHasBuyOnline = buyOnlineData['@OnlineRetailingPreferredVIN'];
                //             if (buyOnlineData['@OnlineRetailingPreferredVIN']) {
                //             svehicle1.attr('data-tap-dealer-options','buyonline');                             
                //             }
                //         }
                //         svehicle1.attr('data-tap-model-name',data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelGroupName"]);
                //         svehicle1.attr('data-tap-model-year',data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelYear"]);
                //         svehicle1.attr('data-tap-model-trim',data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelTrim"]);
                //         svehicle1.attr('data-tap-model-mspr',data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["DSRP"]);
                //         svehicle1.attr('data-tap-model-exterior-color',data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelExteriorColorName"]);
                //         svehicle1.attr('data-tap-model-interior-color',data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelInteriorColorName"]);
                //         let ProgramID = (vehicleType != 'U') ? cpoTier === 'BT' : 'presicion_used' ? 'precision_certified':'used';
                //         svehicle1.attr('data-tap-model-program-id',ProgramID);
                //         // svehicle1.attr('data-tap-offer-type','finance');
                //         // svehicle1.attr('data-tap-offer-monthly','');
                //         // svehicle1.attr('data-tap-offer-term',thisModelData.SampleTerm);
                //         // svehicle1.attr('data-tap-offer-description',thisModelData.Specials.SpecialDescription);
                //         // svehicle1.attr('data-tap-offer-availability',thisModelData.Specials.EndDate);
                //         // svehicle1.attr('data-tap-offer-id',thisModelData.Specials.SpecialID);
                //         //end tap

                //         break;
                //     }
                //     veh_count = veh_count + 1
                // }
                // var dealer = getDealerObject(data, 'DealerID', _1similarmodeldealerid);
                // var _1similarmodeldealername = dealer[0]['DealerName']
                // var _1dealerurl = dealer[0]['DealerURL']

                // //tap dealer 

                // svehicle1.attr('data-tap-dealer-id', dealer[0]['DealerID']);
                // svehicle1.attr('data-tap-dealer-name',dealer[0]['DealerName']);
                // svehicle1.attr('data-tap-dealer-distance',dealer[0]['DealerDistance']);
                //end

                ///// SIMILAR VEHICLE 2
                //LOOP THROUGH DATA, MAKE SURE SIMILAR VEHICLE 2 DOESNT MATCH CURRENT VEHICLE IN VDP
                // veh_count = 0;
                // for (var vehicle in data["Output"]["Results"]["Models"]["Model"]) {
                //     var _2similarmodelvin = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["VIN"]
                //     var _2similarmodelvehicle_type = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["VehicleType"]
                //     var _2similarmodelcpotier = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["CPOTier"]
                //     if ((thisModelData.VIN != _2similarmodelvin) && (_1similarmodelvin != _2similarmodelvin) && (_2similarmodelvehicle_type == vehicleType) && _2similarmodelcpotier == cpoTier) {
                //         //console.clear;
                //         //console.log('[name=_vin] :', $('[name=_vin]').val());
                //         //console.log('_1similarmodelvin :', _1similarmodelvin);
                //         //console.log('_2similarmodelvin :', _2similarmodelvin);
                //         var _2similarmodelYear = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelYear"]
                //         var _2similarmodelgroup = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelGroupName"]
                //         var _2similarmodelpackage = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelMarketingName"]
                //         var _2similarmodelprice = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["DSRP"]
                //         var _2similarmodelmiles = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["Mileage"]
                //         var _2similarmodeldealerid = data["Output"]["Results"]["Models"]["Model"][veh_count]["@DealerId"]
                //         // var _2vehicleamount = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["Subscription"]["@Amount"]
                //         // var _2vehicleurl= data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["Subscription"]["#text"]
                //         var _2similarmodelimage = thisModelData.VehicleImage;
                //         if (data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["Photos"] != null) {
                //             //get dealer photos
                //             if (data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["Photos"]["Photos"]["Photo"][0]["#text"] != null) {
                //                 _2similarmodelimage = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["Photos"]["Photos"]["Photo"][0]["#text"]
                //             }
                //             //get stock photos
                //         } else if (data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["ModelStockPhotos"] != null &&
                //             data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["ModelStockPhotos"]["Photos"][0]["Photo"] != null &&
                //             data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["ModelStockPhotos"]["Photos"][0]["Photo"][0]["#text"] != null) {
                //             _2similarmodelimage = _similarveh_url + data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["ModelStockPhotos"]["Photos"][0]["Photo"][0]["#text"]
                //         } else {
                //             //no photos avail. set to no image 
                //             _2similarmodelimage = thisModelData.PhotosNoImage;
                //         }

                //         //for tap
                //         //set vdp wrapper tap data
                //         svehicle2.attr('data-tap-element-id','similar-vehicle');
                //         let simvin = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]
                //         let buyOnlineData = (simvin["BuyOnline"] == null || simvin["BuyOnline"] == 'undefined') ? null : simvin["BuyOnline"];
                //         let simHasBuyOnline;
                //         if (buyOnlineData != null) { 
                //             simHasBuyOnline = buyOnlineData['@OnlineRetailingPreferredVIN'];
                //             if (buyOnlineData['@OnlineRetailingPreferredVIN']) {
                //             svehicle2.attr('data-tap-dealer-options','buyonline');                             
                //             }
                //         }
                //         svehicle2.attr('data-tap-model-name',data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelGroupName"]);
                //         svehicle2.attr('data-tap-model-year',data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelYear"]);
                //         svehicle2.attr('data-tap-model-trim',data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelTrim"]);
                //         svehicle2.attr('data-tap-model-mspr',data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["DSRP"]);
                //         svehicle2.attr('data-tap-model-exterior-color',data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelExteriorColorName"]);
                //         svehicle2.attr('data-tap-model-interior-color',data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelInteriorColorName"]);
                //         let ProgramID = (vehicleType != 'U') ? cpoTier === 'BT' ? 'precision_used' : 'precision_certified':'used';
                //         svehicle2.attr('data-tap-model-program-id',ProgramID);
                //         // svehicle1.attr('data-tap-offer-type','finance');
                //         // svehicle1.attr('data-tap-offer-monthly','');
                //         // svehicle1.attr('data-tap-offer-term',thisModelData.SampleTerm);
                //         // svehicle1.attr('data-tap-offer-description',thisModelData.Specials.SpecialDescription);
                //         // svehicle1.attr('data-tap-offer-availability',thisModelData.Specials.EndDate);
                //         // svehicle1.attr('data-tap-offer-id',thisModelData.Specials.SpecialID);
                //         //end tap

                //         break;
                //     }
                //     veh_count = veh_count + 1
                // }
                // dealer = getDealerObject(data, 'DealerID', _2similarmodeldealerid);
                // var _2similarmodeldealername = dealer[0]['DealerName']
                // var _2dealerurl = dealer[0]['DealerURL']


                // //tap dealer 
                // svehicle2.attr('data-tap-dealer-id', dealer[0]['DealerID']);
                // svehicle2.attr('data-tap-dealer-name',dealer[0]['DealerName']);
                // svehicle2.attr('data-tap-dealer-distance',dealer[0]['DealerDistance']);
                // //end                
                
                ///// SIMILAR VEHICLE 3
                //LOOP THROUGH DATA, MAKE SURE SIMILAR VEHICLE 3 DOESNT MATCH CURRENT VEHICLE IN VDP
                // veh_count = 0;
                // for (var vehicle in data["Output"]["Results"]["Models"]["Model"]) {
                //     var _3similarmodelvin = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["VIN"]
                //     var _3similarmodelvehicle_type = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["VehicleType"]
                //     var _3similarmodelcpotier = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["CPOTier"]
                //     if ((thisModelData.VIN != _3similarmodelvin) && (_3similarmodelvin != _2similarmodelvin) && (_3similarmodelvin != _1similarmodelvin) && (_3similarmodelvehicle_type == vehicleType)  && _3similarmodelcpotier == cpoTier) {
                //         console.clear;
                //         //console.log('[name=_vin] :', $('[name=_vin]').val());
                //         //console.log('_1similarmodelvin :', _1similarmodelvin);
                //         //console.log('_2similarmodelvin :', _2similarmodelvin);
                //         //console.log('_3similarmodelvin :', _3similarmodelvin);
                //         var _3similarmodelYear = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelYear"]
                //         var _3similarmodelgroup = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelGroupName"]
                //         var _3similarmodelpackage = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelMarketingName"]
                //         var _3similarmodelprice = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["DSRP"]
                //         var _3similarmodelmiles = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["Mileage"]
                //         var _3similarmodeldealerid = data["Output"]["Results"]["Models"]["Model"][veh_count]["@DealerId"]
                //         // var _3vehicleamount = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["Subscription"]["@Amount"]
                //         // var _3vehicleurl= data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["Subscription"]["#text"]
                //         var _3similarmodelimage = thisModelData.VehicleImage;
                //         if (data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["Photos"] != null) {
                //             //get dealer photos 
                //             if (data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["Photos"]["Photos"]["Photo"][0]["#text"] != null) {
                //                 // console.log('------------------------ getSimilarVehicles get dealer photos  ----------------------------------------');
                //                 _3similarmodelimage = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["Photos"]["Photos"]["Photo"][0]["#text"]
                //             }
                //             //get stock photos if dealer photos == null
                //         } else if (data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["ModelStockPhotos"] != null &&
                //             data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["ModelStockPhotos"]["Photos"][0]["Photo"] != null &&
                //             data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["ModelStockPhotos"]["Photos"][0]["Photo"][0]["#text"] != null) {
                //             // console.log('------------------------ getSimilarVehicles get dealer photos 3----------------------------------------');
                //             _3similarmodelimage = _similarveh_url + data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["ModelStockPhotos"]["Photos"][0]["Photo"][0]["#text"]
                //         } else {
                //             //no photos avail. set to no image 
                //             // console.log('------------------------ getSimilarVehicles get dealer photos NULL----------------------------------------');
                //             _3similarmodelimage = thisModelData.PhotosNoImage;
                //         }

                //         //for tap
                //         //set vdp wrapper tap data
                //         svehicle3.attr('data-tap-element-id','similar-vehicle');
                //         let simvin = data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]
                //         let buyOnlineData = (simvin["BuyOnline"] == null || simvin["BuyOnline"] == 'undefined') ? null : simvin["BuyOnline"];
                //         let simHasBuyOnline;
                //         if (buyOnlineData != null) { 
                //             simHasBuyOnline = buyOnlineData['@OnlineRetailingPreferredVIN'];
                //             if (buyOnlineData['@OnlineRetailingPreferredVIN']) {
                //             svehicle3.attr('data-tap-dealer-options','buyonline');                             
                //             }
                //         }
                //         svehicle3.attr('data-tap-model-name',data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelGroupName"]);
                //         svehicle3.attr('data-tap-model-year',data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelYear"]);
                //         svehicle3.attr('data-tap-model-trim',data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelTrim"]);
                //         svehicle3.attr('data-tap-model-mspr',data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelVINsOnSite"]["VIN"][0]["DSRP"]);
                //         svehicle3.attr('data-tap-model-exterior-color',data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelExteriorColorName"]);
                //         svehicle3.attr('data-tap-model-interior-color',data["Output"]["Results"]["Models"]["Model"][veh_count]["ModelInteriorColorName"]);
                //         let ProgramID = (vehicleType != 'U') ? cpoTier === 'BT' ? 'precision_used' : 'precision_certified':'used';
                //         svehicle3.attr('data-tap-model-program-id',ProgramID);
                //         // svehicle1.attr('data-tap-offer-type','finance');
                //         // svehicle1.attr('data-tap-offer-monthly','');
                //         // svehicle1.attr('data-tap-offer-term',thisModelData.SampleTerm);
                //         // svehicle1.attr('data-tap-offer-description',thisModelData.Specials.SpecialDescription);
                //         // svehicle1.attr('data-tap-offer-availability',thisModelData.Specials.EndDate);
                //         // svehicle1.attr('data-tap-offer-id',thisModelData.Specials.SpecialID);
                //         //end tap

                //         break;
                //     }
                //     veh_count = veh_count + 1
                // }
                // // console.log('getSimilarVehicles - 3...', _3similarmodeldealerid);
                // dealer = getDealerObject(data, 'DealerID', _3similarmodeldealerid);
                // var _3similarmodeldealername = dealer[0]['DealerName']
                // var _3dealerurl = dealer[0]['DealerURL']

                // //tap dealer 
                // svehicle3.attr('data-tap-dealer-id', dealer[0]['DealerID']);
                // svehicle3.attr('data-tap-dealer-name',dealer[0]['DealerName']);
                // svehicle3.attr('data-tap-dealer-distance',dealer[0]['DealerDistance']);
                // //end

                //console.clear;

                //console.log('_1similarmodelYear: ', _1similarmodelYear);
                //console.log('_1similarmodelgroup: ', _1similarmodelgroup);
                //console.log('_1similarmodelpackage:', _1similarmodelpackage);
                //console.log('_1similarmodelprice: ', _1similarmodelprice);
                //console.log('_1similarmodelmiles:', _1similarmodelmiles);
                //console.log('_1similarmodeldealerid', _1similarmodeldealerid);
                //console.log(' _1similarmodelvin:', _1similarmodelvin);
                //console.log(' _3similarmodelimage:', _3similarmodelimage);
                //console.log('--------------------------------------------------------------------------');  
                //#region hack DOM to show similar vehicles
                // $('#similar-vehicles-wrapper-1').removeClass('item similar-vehicle bg-light-grey hidden').addClass('item similar-vehicle bg-light-grey');
                // $('#similar-vehicles-wrapper-2').removeClass('item similar-vehicle bg-light-grey hidden').addClass('item similar-vehicle bg-light-grey');
                // $('#similar-vehicles-wrapper-3').removeClass('item similar-vehicle bg-light-grey hidden').addClass('item similar-vehicle bg-light-grey');
                // Verify type of car
                // let type = vehicleType !== 'U' ? cpoTier === 'BT' ? 'precision-used' : 'precision' : 'used';
                // $('#vehicle-type-1').removeClass('vehicle-precision-type hidden').addClass(`vehicle-${type}-type`).html(`<span>${_1similarmodelvehicle_type !== 'U' ? _1similarmodelcpotier === 'BT' ? 'Precision Used' : 'Precision Certified' : 'Used Vehicle'}</span>`);
                // $('#vehicle-type-2').removeClass('vehicle-precision-type hidden').addClass(`vehicle-${type}-type`).html(`<span>${_2similarmodelvehicle_type !== 'U' ? _2similarmodelcpotier === 'BT' ? 'Precision Used' : 'Precision Certified' : 'Used Vehicle'}</span>`);
                // $('#vehicle-type-3').removeClass('vehicle-precision-type hidden').addClass(`vehicle-${type}-type`).html(`<span>${_3similarmodelvehicle_type !== 'U' ? _3similarmodelcpotier === 'BT' ? 'Precision Used' : 'Precision Certified' : 'Used Vehicle'}</span>`);
                // // Add fair price if it has
                // if(_1vehicleamount !== ''){
                //     $('#similar-vehicles-wrapper-1').addClass('vehicle-fair');
                //     $('#btn-detail-vehicle-1').addClass('btn-fair');
                //     $('#show-fair-vehicle-1').removeClass('hidden');
                //     $('#url-vehicle-1').attr("href", _1vehicleurl);
                //     $('#_1vehicle_fair_amount').html(`$${parseInt(_1vehicleamount)}`);
                // }

                // if(_2vehicleamount !== ''){
                //     $('#similar-vehicles-wrapper-2').addClass('vehicle-fair');
                //     $('#btn-detail-vehicle-2').addClass('btn-fair');
                //     $('#show-fair-vehicle-2').removeClass('hidden');
                //     $('#url-vehicle-2').attr("href", _2vehicleurl);
                //     $('#_2vehicle_fair_amount').html(`$${parseInt(_2vehicleamount)}`);
                // }

                // if(_3vehicleamount !== ''){
                //     $('#similar-vehicles-wrapper-3').addClass('vehicle-fair');
                //     $('#btn-detail-vehicle-3').addClass('btn-fair');
                //     $('#show-fair-vehicle-3').removeClass('hidden');
                //     $('#url-vehicle-3').attr("href", _3vehicleurl);
                //     $('#_3vehicle_fair_amount').html(`$${parseInt(_3vehicleamount)}`);
                // }
                //href links
                // $('#contact-dealer-button-bottom-left').attr("href", "/vehicle-details?vin=" + _1similarmodelvin)
                // $('#contact-dealer-button-bottom-middle').attr("href", "/vehicle-details?vin=" + _2similarmodelvin)
                // $('#contact-dealer-button-bottom-right').attr("href", "/vehicle-details?vin=" + _3similarmodelvin)
                // //images change
                // $('#similar-vehicles-img-1').html("<img src='" + _1similarmodelimage + "'>")
                // $('#similar-vehicles-img-2').html("<img src='" + _2similarmodelimage + "'>")
                // $('#similar-vehicles-img-3').html("<img src='" + _3similarmodelimage + "'>")
                // //copy left change
                // $('#similar-vehicles-copyleft-1').html('<p class="year-model hl-8">' + _1similarmodelYear + ' ' + _1similarmodelgroup + '</p>' + (_1similarmodelpackage === null ? '<p class="package cp-6" style="visibility:hidden;">PACKAGE' : _1similarmodelpackage.replace("with", "")) + '</p> <p class="miles cp-6">' + addCommas(_1similarmodelmiles) + ' miles</p><p class="dealer cp-11"><span class="acpv-icon pin-black" style="width: 21px; height: 17px;"></span></span><a href="' + _1dealerurl + '" target="_blank" style="color: black; text-decoration: underline; margin-top: 4px; width: 100%;" data-tracking="vehdetails_dealer_website">'+ _1similarmodeldealername +'</a></p></div>')
                // $('#similar-vehicles-copyleft-2').html('<p class="year-model hl-8">' + _2similarmodelYear + ' ' + _2similarmodelgroup + '</p>' + (_2similarmodelpackage === null ? '<p class="package cp-6" style="visibility:hidden;">PACKAGE' : _2similarmodelpackage.replace("with", "")) + '</p> <p class="miles cp-6">' + addCommas(_2similarmodelmiles) + ' miles</p><p class="dealer cp-11"><span class="acpv-icon pin-black" style="width: 21px; height: 17px;"></span></span><a href="' + _2dealerurl + '" target="_blank" style="color: black; text-decoration: underline; margin-top: 4px; width: 100%;" data-tracking="vehdetails_dealer_website">'+ _2similarmodeldealername +'</a></p></div>')
                // $('#similar-vehicles-copyleft-3').html('<p class="year-model hl-8">' + _3similarmodelYear + ' ' + _3similarmodelgroup + '</p>' + (_3similarmodelpackage === null ? '<p class="package cp-6" style="visibility:hidden;">PACKAGE' : _3similarmodelpackage.replace("with", "")) + '</p> <p class="miles cp-6">' + addCommas(_3similarmodelmiles) + ' miles</p><p class="dealer cp-11"><span class="acpv-icon pin-black" style="width: 21px; height: 17px;"></span></span><a href="' + _3dealerurl + '" target="_blank" style="color: black; text-decoration: underline; margin-top: 4px; width: 100%;" data-tracking="vehdetails_dealer_website">'+ _3similarmodeldealername +'</a></p></div>')
                // //copy right change
                // //$('#similar-vehicles-copright-1').html(' <p class="price hl-9">' + formatCurrency(_1similarmodelprice) + '</p><p class="offer cp-12 color-red">OFFER<br /> AVAILABLE</p></div>')
                // //$('#similar-vehicles-copright-2').html(' <p class="price hl-9">' + formatCurrency(_2similarmodelprice) + '</p><p class="offer cp-12 color-red">OFFER<br /> AVAILABLE</p></div>')
                // //$('#similar-vehicles-copright-3').html(' <p class="price hl-9">' + formatCurrency(_3similarmodelprice) + '</p><p class="offer cp-12 color-red">OFFER<br /> AVAILABLE</p></div>')
                // $('#similar-vehicles-copright-1').html(' <p class="price hl-9">' + formatCurrency(_1similarmodelprice) + '</p>')
                // $('#similar-vehicles-copright-2').html(' <p class="price hl-9">' + formatCurrency(_2similarmodelprice) + '</p>')
                // $('#similar-vehicles-copright-3').html(' <p class="price hl-9">' + formatCurrency(_3similarmodelprice) + '</p>')

                // if((_1similarmodelvehicle_type === '' || _1similarmodelvehicle_type === null) && (_2similarmodelvehicle_type === '' || _2similarmodelvehicle_type === null) && 
                // (_3similarmodelvehicle_type === '' || _3similarmodelvehicle_type === null)) {
                //     //$('#similarvehicles').css("display", "none");
                // }

                //#endregion
            } else {
                $('#similarvehicles, .similar-vehicles-wrapper').addClass('hidden');
            }
            //load all Dealer info in the VDP 
            // console.log('getSimilarVehicles - done...');

        }
        catch (err) {
            console.log('err similar vehicles:', err)
            $('.spinner').hide();
            $('#similarvehicles').css("display", "none");
        }
    }
}


//#endregion
